<template>
   <div class="!w-full">
      <v-container fluid no-gutters font-sans class="!m-0 !p-0 dark:!bg-csenBlue-900" >
            <v-form v-model="validForm" ref="formTecnico">
               <v-row no-gutters class="dark:!bg-csenBlue-900">

                  <!-- Colonna delle tab -->
                  <v-col cols="12" sm="3" class="!bg-gray-200 dark:!bg-csenBlue-700">
                     <v-list class="!p-4 !bg-gray-200 dark:!bg-csenBlue-700 flex flex-row sm:flex-col">

                        <v-list-item
                           v-for="(item, index) in tabs"
                           :key="index"
                           v-if="!item.only_admin || (item.only_admin && loggedAs.ruolo == 'admin')"
                           :class="{ '!bg-csenBlue-900 !text-white dark:!bg-csenBlue-900': tab === index }"
                           @click="tabAnchorClick(index)"
                           class="cursor-pointer rounded-md bg-white dark:!text-csenBlue-100 dark:!bg-csenBlue-600 my-2 font-semibold"
                        >
                           <v-list-item-icon>
                              <component :is="item.icon" class="w-6 h-6"></component>
                           </v-list-item-icon>
                           <v-list-item-content>
                              <v-list-item-title class="!flex !justify-between !items-start !text-[0.95rem]" :id="item.id">
                                 {{ item.title }}
                                 
                                 <!-- Icone e Tooltip in caso di modifica o dato aggiornato -->
                                 <v-icon v-if="tecnico.id != null && sezioniModificate[item.short] && (item.short == 'rinnovi' || item.short == 'diplomi')" color="green">mdi-check-circle</v-icon>
                                 <!-- <EditingIcon v-else-if="tecnico.id != null && sezioniModificate[item.short]" class="my-auto !h-5 !w-5 text-yellow-500"></EditingIcon> -->
                                 <v-tooltip v-else-if="tecnico.id != null && sezioniModificate[item.short]" bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                       <span v-bind="attrs" v-on="on">
                                          <EditingIcon class="my-auto !h-5 !w-5 !text-yellow-500" />
                                       </span>
                                    </template>
                                    <span>Modifica non ancora salvata</span>
                                 </v-tooltip>

                                 <!-- Tooltip per l'icona di mancato rinnovo -->
                                 <v-tooltip v-if="loggedAs.ruolo == 'tecnico' && item.short == 'rinnovi' && isRinnovoScadutoComputed" bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                       <span v-bind="attrs" v-on="on">
                                          <WarningIcon class="my-auto !h-5 !w-5 !text-csenRed-500 dark:!text-csenRed-600" />
                                       </span>
                                    </template>
                                    <span>Effettua il rinnovo per l'anno in corso per essere nuovamente inserito nell'albo tecnici CSEN.<br/>
                                       Senza il rinnovo per l'anno in corso non risulterai inserito nel RASD e non sarai coperto dall'assicurazione</span>
                                 </v-tooltip>

                              </v-list-item-title>
                           </v-list-item-content>
                        </v-list-item>
                     </v-list>
                  </v-col>



                  <!-- Colonna dei contenuti -->
                  <v-col cols="12" sm="9" class="dark:!bg-csenBlue-900">
                     <v-tabs-items v-model="tab" class="dark:!bg-csenBlue-900">

                     <!-- TAB DATI ANAGRAFICI -->
                     <v-tab-item :eager="true" class="dark:!bg-csenBlue-900">
                        <v-card flat class="p-9 dark:!bg-csenBlue-900 w-full !rounded-none !ring-0 !border-0" >
                           <!-- Testo iniziale -->
                           <v-row dense >
                              <div id="AnchorDatiAnagrafici">
                                 <h2 class="text-xl font-bold text-csenBlue-950 dark:text-csenBlue-200">Dati anagrafici</h2>
                                 <p class="pt-1 text-sm">Dati anagrafici del tecnico inseriti in fase di registrazione. </p>
                               
                               </div>
                           </v-row>
                           <!-- Riga 1 -->
                           <!-- Nome e Cognome-->

                           <v-row dense class="mb-n3">
                              
                              <v-col cols="12" md="12">
                              <div v-if="loggedAs && loggedAs.ruolo=='tecnico'"> 
                                 <p class="text-sm text-csenBlue-900 dark:!text-white font-semibold italic">Per modificare i dati anagrafici scrivere all'indirizzo <a target="_blank" class="!text-csenOrange-600 hover:!!text-csenOrange-500 underline" href="mailto:info@tecnici.csencorsi.it"> info@tecnici.csencorsi.it</a></p>
                              </div> 
                             </v-col>
                                 
                             <v-col cols="12" md="6">
                                 <v-text-field
                                    label="Nome"
                                    v-model="tecnico.nome"
                                    :rules="!isEmpatikAdmin() ? [rules.requiredAtLeast3] : []"
                                    outlined
                                    :readonly="(loggedAs && loggedAs.ruolo == 'tecnico' && tecnico.nome != null && tecnico.nome != '' && !tecnicoCampiModificati['nome'])"
                                    :disabled="(loggedAs && loggedAs.ruolo == 'tecnico' && tecnico.nome != null && tecnico.nome != '' && !tecnicoCampiModificati['nome'])"
                                    @input="setTecnicoCampoModificato('nome')"
                                 >
                                    <template v-slot:append>

                                       <v-tooltip  v-if="tecnico.id != null && tecnicoCampiModificati['nome']"  bottom>
                                          <template v-slot:activator="{ on, attrs }">
                                             <span v-bind="attrs" v-on="on">
                                                <EditingIcon class="my-auto !h-5 !w-5 !text-yellow-500" />
                                             </span>
                                          </template>
                                          <span>Modifica non ancora salvata</span>
                                       </v-tooltip>

                                       <LockIcon v-if="(loggedAs && loggedAs.ruolo == 'tecnico')" class="my-auto !h-5 !w-5 cursor-not-allowed"></LockIcon>  
                                    </template>
                                 </v-text-field>
                              </v-col>

                             


                              <v-col cols="12" md="6">
                                 <v-text-field
                                    label="Cognome"
                                    v-model="tecnico.cognome"
                                    :rules="!isEmpatikAdmin() ? [rules.requiredAtLeast3] : []"
                                    outlined
                                    :readonly="(loggedAs && loggedAs.ruolo == 'tecnico' && tecnico.cognome != null && tecnico.cognome != '' && !tecnicoCampiModificati['cognome'])"
                                    :disabled="(loggedAs && loggedAs.ruolo == 'tecnico' && tecnico.cognome != null && tecnico.cognome != '' && !tecnicoCampiModificati['cognome'])"
                                    @input="setTecnicoCampoModificato('cognome')"
                                    >
                                    <template v-slot:append>
                                       <v-tooltip  v-if="tecnico.id != null && tecnicoCampiModificati['cognome']"  bottom>
                                          <template v-slot:activator="{ on, attrs }">
                                             <span v-bind="attrs" v-on="on">
                                                <EditingIcon class="my-auto !h-5 !w-5 !text-yellow-500" />
                                             </span>
                                          </template>
                                          <span>Modifica non ancora salvata</span>
                                       </v-tooltip>                                      
                                       <LockIcon v-if="(loggedAs && loggedAs.ruolo == 'tecnico')" class="my-auto !h-5 !w-5 cursor-not-allowed"></LockIcon>  
                                    </template>
                                 </v-text-field>
                              </v-col>
                             
                           </v-row>
                           <!-- Riga 2 -->
                           <v-row dense class="mb-n3">
                              <!-- Sesso-->
                              <v-col cols="12" md="2">
                                 <v-select
                                    :items="[
                                       {
                                       'label': 'Maschio',
                                       'value': 'M'
                                       },
                                       {
                                       'label': 'Femmina',
                                       'value': 'F'
                                       },
                                    ]"
                                    label="Sesso"
                                    v-model="tecnico.sesso"
                                    item-text="label"
                                    item-value="value"
                                    outlined
                                    :rules="!isEmpatikAdmin() ? [rules.required] : []"
                                    :readonly="(loggedAs && loggedAs.ruolo == 'tecnico' && tecnico.sesso != null && tecnico.sesso != '' && !tecnicoCampiModificati['sesso'])"
                                    :disabled="(loggedAs && loggedAs.ruolo == 'tecnico' && tecnico.sesso != null && tecnico.sesso != '' && !tecnicoCampiModificati['sesso'])"
                                    @input="setTecnicoCampoModificato('sesso')"
                                 >
                                    <template v-slot:append> 
                                       <v-tooltip  v-if="tecnico.id != null && tecnicoCampiModificati['sesso']"   bottom>
                                          <template v-slot:activator="{ on, attrs }">
                                             <span v-bind="attrs" v-on="on">
                                                <EditingIcon class="my-auto !h-5 !w-5 !text-yellow-500" />
                                             </span>
                                          </template>
                                          <span>Modifica non ancora salvata</span>
                                       </v-tooltip> 
                                       <LockIcon v-if="(loggedAs && loggedAs.ruolo == 'tecnico')" class="my-auto !h-5 !w-5 cursor-not-allowed"></LockIcon>  
                                    </template>
                                 </v-select>
                              </v-col>
                              <!-- Luogo di Nascita-->
                              <v-col cols="12" md="4" class="!z-50">
                                 <v-autocomplete
                                    autocomplete="none"
                                    :items="province"
                                    item-value="sigla"
                                    item-text="nome"
                                    label="Provincia di Nascita"
                                    v-model="tecnico.sigla_provincia_nascita"
                                    outlined
                                    class="!z-50"
                                    :rules="!isEmpatikAdmin() ? [rules.required] : []"
                                    @input="setTecnicoCampoModificato('sigla_provincia_nascita')"
                                    :readonly="(loggedAs && loggedAs.ruolo == 'tecnico' && tecnico.sigla_provincia_nascita != null && tecnico.sigla_provincia_nascita != '' && !tecnicoCampiModificati['sigla_provincia_nascita'])"
                                    :disabled="(loggedAs && loggedAs.ruolo == 'tecnico' && tecnico.sigla_provincia_nascita != null && tecnico.sigla_provincia_nascita != '' && !tecnicoCampiModificati['sigla_provincia_nascita'])"
                                    >
                                    <template v-slot:append>
                                       <v-tooltip v-if="tecnico.id != null && tecnicoCampiModificati['sigla_provincia_nascita']" bottom>
                                          <template v-slot:activator="{ on, attrs }">
                                             <span v-bind="attrs" v-on="on">
                                                <EditingIcon class="my-auto !h-5 !w-5 !text-yellow-500" />
                                             </span>
                                          </template>
                                          <span>Modifica non ancora salvata</span>
                                       </v-tooltip> 
                                       <LockIcon v-if="(loggedAs && loggedAs.ruolo == 'tecnico')" class="my-auto !h-5 !w-5 cursor-not-allowed"></LockIcon>  
                                    </template>
                                 </v-autocomplete>
                              </v-col>
                              <v-col cols="12" md="3" class="!z-50">
                                 <v-autocomplete
                                    autocomplete="none"
                                    :items="comuniByProvinciaNascita"
                                    item-value="nome"
                                    item-text="nome"
                                    label="Città di Nascita"
                                    v-model="tecnico.comune_nascita"
                                    :rules="!isEmpatikAdmin() ? [rules.required] : []"
                                    outlined
                                    class="!z-50"
                                    @input="setTecnicoCampoModificato('comune_nascita')"
                                    :readonly="(loggedAs && loggedAs.ruolo == 'tecnico' && tecnico.comune_nascita != null && tecnico.comune_nascita != '' && !tecnicoCampiModificati['comune_nascita'])"
                                    :disabled="(loggedAs && loggedAs.ruolo == 'tecnico' && tecnico.comune_nascita != null && tecnico.comune_nascita != '' && !tecnicoCampiModificati['comune_nascita'])"
                                    >
                                    <template v-slot:append>
                                       <v-tooltip v-if="tecnico.id != null && tecnicoCampiModificati['comune_nascita']" bottom>
                                          <template v-slot:activator="{ on, attrs }">
                                             <span v-bind="attrs" v-on="on">
                                                <EditingIcon class="my-auto !h-5 !w-5 !text-yellow-500" />
                                             </span>
                                          </template>
                                          <span>Modifica non ancora salvata</span>
                                       </v-tooltip> 
                                       <LockIcon v-if="(loggedAs && loggedAs.ruolo == 'tecnico')" class="my-auto !h-5 !w-5 cursor-not-allowed"></LockIcon>  
                                    </template>
                                 </v-autocomplete>
                              </v-col>
                              <!-- Data di Nascita -->
                              <v-col cols="12" md="3">
                                 <v-text-field
                                    v-model="tecnico.data_nascita"
                                    label="Data di Nascita"
                                    outlined
                                    :rules="!isEmpatikAdmin() ? [rules.required] : []"
                                    type="date"
                                    @input="setTecnicoCampoModificato('data_nascita')"
                                    :readonly="(loggedAs && loggedAs.ruolo == 'tecnico' && tecnico.data_nascita != null && tecnico.data_nascita != '' && !tecnicoCampiModificati['data_nascita'])"
                                    :disabled="(loggedAs && loggedAs.ruolo == 'tecnico' && tecnico.data_nascita != null && tecnico.data_nascita != '' && !tecnicoCampiModificati['data_nascita'])"
                                    >
                                    <template v-slot:append>
                                       
                                    <v-tooltip v-if="tecnico.id != null && tecnicoCampiModificati['data_nascita']" bottom>
                                          <template v-slot:activator="{ on, attrs }">
                                             <span v-bind="attrs" v-on="on">
                                                <EditingIcon class="my-auto !h-5 !w-5 !text-yellow-500" />
                                             </span>
                                          </template>
                                          <span>Modifica non ancora salvata</span>
                                       </v-tooltip> 
                                       <LockIcon v-if="(loggedAs && loggedAs.ruolo == 'tecnico')" class="my-auto !h-5 !w-5 cursor-not-allowed"></LockIcon>  
                                    
                                    </template>
                                 </v-text-field>
                              </v-col>
                           </v-row>
                           <!-- Riga 3 -->
                           <!-- Codice Fiscale -->
                           <template>
                              <v-row dense>
                                 <v-col :cols="isCodiceFiscaleModificabileComputed && !isLoadingCodiceFiscale && tecnico.sigla_provincia_nascita != 'EE' ? 11 : 12">
                                    <v-text-field
                                       :loading="isLoadingCodiceFiscale"
                                       :label="'Codice Fiscale '+ (tecnico.is_codice_fiscale_manuale == 1 ? ' (Manuale)' : '(Automatico)')"
                                       :readonly="!tecnico.is_codice_fiscale_manuale || (loggedAs.ruolo == 'tecnico' && !isCodiceFiscaleModificabileComputed)"
                                       :disabled="!tecnico.is_codice_fiscale_manuale || (loggedAs.ruolo == 'tecnico' && !isCodiceFiscaleModificabileComputed)"
                                       outlined
                                       v-model="tecnico.codice_fiscale"
                                       :rules="!isEmpatikAdmin() ? [rules.required, rules.codice_fiscale] : [rules.codice_fiscale]"
                                       @input="setTecnicoCampoModificato('codice_fiscale')"
                                    >
                                       <template v-slot:append>
                                          <v-tooltip v-if="tecnico.id != null && tecnicoCampiModificati['codice_fiscale']" bottom>
                                          <template v-slot:activator="{ on, attrs }">
                                             <span v-bind="attrs" v-on="on">
                                                <EditingIcon class="my-auto !h-5 !w-5 !text-yellow-500" />
                                             </span>
                                          </template>
                                          <span>Modifica non ancora salvata</span>
                                          </v-tooltip> 
                                          <LockIcon v-if="(loggedAs && loggedAs.ruolo == 'tecnico') || !tecnico.is_codice_fiscale_manuale" class="my-auto !h-5 !w-5 cursor-not-allowed"></LockIcon>  
                                       </template>
                                    </v-text-field>
                                 </v-col>
                                 <v-col cols="1" v-if="isCodiceFiscaleModificabileComputed && !isLoadingCodiceFiscale && tecnico.sigla_provincia_nascita != 'EE'">
                                       <!-- Nota: Se non si mette il type="button" nel <button> verrà fatto il submit ricaricando la pagina! -->
                                       <v-tooltip bottom>
                                          <template v-slot:activator="{ on, attrs }">
                                             <button
                                                v-bind="attrs"
                                                v-on="on"
                                                type="button"
                                                @click="tecnico.is_codice_fiscale_manuale = !tecnico.is_codice_fiscale_manuale"
                                                :class="[
                                                   'inline-flex justify-center content-center w-full h-14 rounded-md transition',
                                                   tecnico.is_codice_fiscale_manuale ? 'ring-1 ring-csenOrange-500 bg-csenOrange-100 !!text-csenOrange-500 dark:!text-white dark:bg-csenOrange-500' : 'bg-gray-100 text-gray-800 dark:bg-csenBlue-700 dark:!text-white',
                                                   'transition hover:!bg-csenOrange-400 hover:!text-white !hover:ring-csenOrange-400'
                                                ]"
                                                title="Modifica Codice Fiscale"
                                             >
                                                <EditIcon class="my-auto" />
                                             </button>
                                          </template>
                                          <span>Modifica manualmente il codice fiscale</span>
                                       </v-tooltip>
                                 </v-col>
                              </v-row>
                           </template>
                           <v-divider></v-divider>
                        </v-card>
                     </v-tab-item>
                     <!-- FINE TAB DATI ANAGRAFICI -->

                        <!-- TAB CONTATTI -->
                        <v-tab-item :eager="true" class="dark:!bg-csenBlue-900 !border-0 !ring-0">
                           <v-card flat class="p-9 dark:!bg-csenBlue-900 w-full !rounded-none !ring-0 !border-0">
                              <!-- Testo iniziale -->
                              <v-row dense>
                                 <div id="AnchorContatti">
                                    <h2 class="text-xl font-bold text-csenBlue-950 dark:text-csenBlue-200">Contatti</h2>
                                    <p class="py-1 text-sm">Contatti e recapiti telefonici. Clicca su "+" per inserire un numero di telefono aggiuntivo.</p>
                                 </div>
                              </v-row>
                              <!-- Riga 1 -->
                              <v-row dense>
                                 <!-- Cellulare -->
                                 <v-col cols="12" md="6">
                                    <v-text-field
                                       label="Cellulare"
                                       v-model="tecnico.cellulare"
                                       outlined
                                       type="tel"
                                       :rules="[rules.phone_number]"
                                       @input="setTecnicoCampoModificato('cellulare')"
                                    >
                                       <template v-slot:append>
                                          <v-tooltip v-if="tecnico.id != null && tecnicoCampiModificati['cellulare']" bottom>
                                          <template v-slot:activator="{ on, attrs }">
                                             <span v-bind="attrs" v-on="on">
                                                <EditingIcon class="my-auto !h-5 !w-5 !text-yellow-500" />
                                             </span>
                                          </template>
                                          <span>Modifica non ancora salvata</span>
                                          </v-tooltip> 
                                       </template>
                                    </v-text-field>
                                 </v-col>
                                 <!-- Telefono Fisso  -->
                                 <v-col cols="12" md="5">
                                    <v-text-field
                                       label="Telefono Fisso"
                                       v-model="tecnico.telefono_fisso"
                                       outlined
                                       type="tel"
                                       :rules="[rules.phone_number]"
                                       @input="setTecnicoCampoModificato('telefono_fisso')"
                                    >
                                       <template v-slot:append>                                      
                                          <v-tooltip v-if="tecnico.id != null && tecnicoCampiModificati['telefono_fisso']" bottom>
                                             <template v-slot:activator="{ on, attrs }">
                                                <span v-bind="attrs" v-on="on">
                                                   <EditingIcon class="my-auto !h-5 !w-5 !text-yellow-500" />
                                                </span>
                                             </template>
                                             <span>Modifica non ancora salvata</span>
                                          </v-tooltip> 
                                       </template>
                                    </v-text-field>
                                 </v-col>
                                 <!-- Pulsante Toggle Altro Numero -->
                                 <v-col cols="12" md="1" class="d-flex !flex align-center !justify-center !items-center -mt-6">
                                    <v-btn icon @click="toggleAltroNumero">
                                       <v-icon
                                          class="bg-csenBlue-900 hover:bg-csenBlue-700 dark:!bg-csenBlue-600 !text-white rounded-full p-4"
                                          title="Aggiungi altro numero di telefono"
                                          >
                                          {{ mostraAltroNumero ? 'mdi-minus' : 'mdi-plus' }}
                                       </v-icon>
                                    </v-btn>
                                 </v-col>
                              </v-row>
                              <!-- Altro Numero di Telefono -->
                              <v-row dense v-if="mostraAltroNumero">
                                 <v-col cols="12">
                                    <v-text-field
                                       label="Altro Numero di Telefono"
                                       v-model="tecnico.altro_numero"
                                       outlined
                                       type="tel"
                                       :rules="[rules.phone_number]"
                                       @input="setTecnicoCampoModificato('altro_numero')"
                                    >
                                       <template v-slot:append>
                                         <v-tooltip v-if="tecnico.id != null && tecnicoCampiModificati['altro_numero']" bottom>
                                             <template v-slot:activator="{ on, attrs }">
                                                <span v-bind="attrs" v-on="on">
                                                   <EditingIcon class="my-auto !h-5 !w-5 !text-yellow-500" />
                                                </span>
                                             </template>
                                             <span>Modifica non ancora salvata</span>
                                          </v-tooltip> 
                                       </template>
                                    </v-text-field>
                                 </v-col>
                              </v-row>
                              <!-- Riga 2 -->
                              <!-- Email -->
                              <v-row dense>
                                 <v-col cols="12">
                                    <v-text-field
                                       label="Email"
                                       v-model="tecnico.email"
                                       outlined
                                       type="email"
                                       :rules="ruleEmailComputed"
                                       @input="setTecnicoCampoModificato('email')"
                                    >
                                       <template v-slot:append> 
                                          <v-tooltip v-if="tecnico.id != null && tecnicoCampiModificati['email']" bottom>
                                             <template v-slot:activator="{ on, attrs }">
                                                <span v-bind="attrs" v-on="on">
                                                   <EditingIcon class="my-auto !h-5 !w-5 !text-yellow-500" />
                                                </span>
                                             </template>
                                             <span>Modifica non ancora salvata</span>
                                          </v-tooltip> 
                                       </template>
                                    </v-text-field>
                                 </v-col>
                              </v-row>
                              <v-divider></v-divider>
                           </v-card>
                        </v-tab-item>
                        <!-- FINE TAB CONTATTI -->
                        
                        <!-- TAB INDIRIZZI -->
                        <!-- NOTA: utilizzato :eager="true" sui v-tab-item per far si che venga caricato subito in modo da validare le rules anche su tab non ancora aperte -->
                        <v-tab-item :eager="true">
                           <v-card flat class="p-9 dark:!bg-csenBlue-900 w-full !rounded-none !ring-0 !border-0">
                                       <!-- Sezione Indirizzo di Residenza -->
                                       <div id="AnchorIndirizzi">
                                             <h2 class="text-xl font-bold mb-4 text-csenBlue-950 dark:text-csenBlue-200">Indirizzo di residenza</h2>
                                             <v-row id="indirizzi-tab-in" dense>
                                                <!-- Ricerca indirizzo -->
                                                <v-col cols="12" md="12" class="!z-50">
                                                   <v-autocomplete
                                                      autocomplete="none"
                                                      v-model="residenzaSelected"
                                                      :items="residenzaOptions"
                                                      :search-input.sync="residenzaSearchText"
                                                      :loading="isLoadingResidenzaSearch"
                                                      label="Cerca indirizzo residenza"
                                                      placeholder="Inizia a scrivere per cercare.."
                                                      open-on-focus
                                                      hide-no-data
                                                      no-filter
                                                      class="!z-10"
                                                      outlined
                                                      item-text="nomeDaMostrare"
                                                      return-object
                                                      :disabled="tecnico.is_manuale_residenza == 1"
                                                   ></v-autocomplete>
                                                   <v-switch
                                                      id="indirizzi-tab-in-manuale"
                                                      label="Inserisci manualmente"
                                                      v-model="tecnico.is_manuale_residenza"
                                                      class="!-mt-3"
                                                   ></v-switch>
                                                </v-col>
                                                <!-- Via / Piazza -->
                                                <v-col cols="12" md="5">

                                                   <v-tooltip text="Toaaoltip">
                                                      <template v-slot:activator="{ props }">

                                                   <v-text-field
                                                         label="Via / Piazza"
                                                         v-model="tecnico.indirizzo_residenza"
                                                         :readonly="tecnico.is_manuale_residenza == 0"
                                                         :disabled="tecnico.is_manuale_residenza == 0"
                                                         outlined
                                                         :rules="!isEmpatikAdmin() ? [rules.required] : []"
                                                         @input="setTecnicoCampoModificato('indirizzo_residenza')"
                                                   >
                                                         <template v-slot:append>
                                                            <LockIcon v-if="tecnico.is_manuale_residenza == 0" class="my-auto !h-5 !w-5 cursor-not-allowed" />
                                                            <v-tooltip v-if="tecnico.id != null && tecnicoCampiModificati['indirizzo_residenza']" bottom>
                                                               <template v-slot:activator="{ on, attrs }">
                                                                     <span v-bind="attrs" v-on="on">
                                                                        <EditingIcon class="my-auto !h-5 !w-5 !text-yellow-500" />
                                                                     </span>
                                                               </template>
                                                               <span>Modifica non ancora salvata</span>
                                                            </v-tooltip>
                                                         </template>

                                                   </v-text-field>
                                                </template></v-tooltip>

                                                </v-col>
                                                <!-- Numero Civico -->
                                                <v-col cols="12" md="4">
                                                   <v-text-field
                                                         label="Civico e altri dettagli"
                                                         v-model="tecnico.civico_residenza"
                                                         outlined
                                                         :readonly="tecnico.is_snc_residenza == 1 || tecnico.is_manuale_residenza == 0"
                                                         :disabled="tecnico.is_snc_residenza == 1 || tecnico.is_manuale_residenza == 0"
                                                         :rules="[rules.numero_civico]"
                                                         @input="setTecnicoCampoModificato('civico_residenza')"
                                                   >
                                                         <template v-slot:append>
                                                            <LockIcon v-if="(tecnico.is_snc_residenza == 1 || tecnico.is_manuale_residenza == 0)" class="my-auto !h-5 !w-5 cursor-not-allowed" />
                                                            <v-tooltip v-if="tecnico.id != null && tecnicoCampiModificati['civico_residenza']" bottom>
                                                               <template v-slot:activator="{ on, attrs }">
                                                                     <span v-bind="attrs" v-on="on">
                                                                        <EditingIcon class="my-auto !h-5 !w-5 !text-yellow-500" />
                                                                     </span>
                                                               </template>
                                                               <span>Modifica non ancora salvata</span>
                                                            </v-tooltip>
                                                         </template>
                                                   </v-text-field>
                                                </v-col>
                                                <!-- SNC -->
                                                <v-col cols="12" md="3" class="flex items-center">
                                                   <v-switch
                                                         label="SNC = Senza Numero Civico"
                                                         v-model="tecnico.is_snc_residenza"
                                                         :disabled="tecnico.is_manuale_residenza == 0"
                                                         class="!-mt-3"
                                                         @input="setTecnicoCampoModificato('civico_residenza')"
                                                   ></v-switch>
                                                </v-col>
                                             </v-row>
                                             <!-- Provincia, Città, CAP -->
                                             <v-row dense>
                                                <v-col cols="12" md="6">
                                                   <v-autocomplete
                                                         v-model="tecnico.nazione_residenza"
                                                         :items="nazioni"
                                                         item-value="nome"
                                                         item-text="nome"
                                                         label="Nazione"
                                                         :readonly="tecnico.is_manuale_residenza == 0"
                                                         :disabled="tecnico.is_manuale_residenza == 0"
                                                         outlined
                                                         :rules="!isEmpatikAdmin() ? [rules.required] : []"
                                                         @input="setTecnicoCampoModificato('nazione_residenza')"

                                                   >
                                                         <template v-slot:append>
                                                            <LockIcon v-if="tecnico.is_manuale_residenza == 0" class="my-auto !h-5 !w-5 cursor-not-allowed" />
                                                            <v-tooltip v-if="tecnico.id != null && tecnicoCampiModificati['nazione_residenza']" bottom>
                                                               <template v-slot:activator="{ on, attrs }">
                                                                     <span v-bind="attrs" v-on="on">
                                                                        <EditingIcon class="my-auto !h-5 !w-5 !text-yellow-500" />
                                                                     </span>
                                                               </template>
                                                               <span>Modifica non ancora salvata</span>
                                                            </v-tooltip>
                                                            <v-icon>
                                                               mdi-chevron-down
                                                            </v-icon>
                                                         </template>
                                                   </v-autocomplete>
                                                </v-col>

                                                <v-col cols="12" md="6">
                                                   <!-- Select per Italia -->
                                                   <v-select
                                                         v-if="tecnico.nazione_residenza === 'ITALIA'"
                                                         :items="province"
                                                         item-value="sigla"
                                                         item-text="nome"
                                                         label="Provincia"
                                                         v-model="tecnico.sigla_provincia_residenza"
                                                         :readonly="tecnico.is_manuale_residenza == 0"
                                                         :disabled="tecnico.is_manuale_residenza == 0"
                                                         outlined
                                                         :rules="!isEmpatikAdmin() ? [rules.required] : []"
                                                         @input="setTecnicoCampoModificato('sigla_provincia_residenza')"
                                                   >
                                                         <template v-slot:append>
                                                            <LockIcon v-if="tecnico.is_manuale_residenza == 0" class="my-auto !h-5 !w-5 cursor-not-allowed" />
                                                            <v-tooltip v-if="tecnico.id != null && tecnicoCampiModificati['sigla_provincia_residenza']" bottom>
                                                               <template v-slot:activator="{ on, attrs }">
                                                                     <span v-bind="attrs" v-on="on">
                                                                        <EditingIcon class="my-auto !h-5 !w-5 !text-yellow-500" />
                                                                     </span>
                                                               </template>
                                                               <span>Modifica non ancora salvata</span>
                                                            </v-tooltip>
                                                            <v-icon>
                                                               mdi-chevron-down
                                                            </v-icon>
                                                         </template>
                                                   </v-select>
                                                   <!-- Text field per altre nazioni -->
                                                   <v-text-field
                                                         v-else
                                                         label="Provincia / Stato"
                                                         v-model="tecnico.sigla_provincia_residenza"
                                                         :readonly="tecnico.is_manuale_residenza == 0"
                                                         :disabled="tecnico.is_manuale_residenza == 0"
                                                         outlined
                                                         :rules="!isEmpatikAdmin() ? [rules.required] : []"
                                                         @input="setTecnicoCampoModificato('sigla_provincia_residenza')"
                                                   >
                                                         <template v-slot:append>
                                                            <LockIcon v-if="tecnico.is_manuale_residenza == 0" class="my-auto !h-5 !w-5 cursor-not-allowed" />
                                                            <v-tooltip v-if="tecnico.id != null && tecnicoCampiModificati['sigla_provincia_residenza']" bottom>
                                                               <template v-slot:activator="{ on, attrs }">
                                                                     <span v-bind="attrs" v-on="on">
                                                                        <EditingIcon class="my-auto !h-5 !w-5 !text-yellow-500" />
                                                                     </span>
                                                               </template>
                                                               <span>Modifica non ancora salvata</span>
                                                            </v-tooltip>
                                                         </template>
                                                   </v-text-field>
                                                </v-col>
                                                <v-col cols="12" md="6">
                                                   <!-- Select per Italia -->
                                                   <v-select
                                                         v-if="tecnico.nazione_residenza === 'ITALIA'"
                                                         :items="comuniByProvinciaResidenza"
                                                         item-value="nome"
                                                         item-text="nome"
                                                         label="Città"
                                                         v-model="tecnico.comune_residenza"
                                                         :readonly="tecnico.is_manuale_residenza == 0"
                                                         :disabled="tecnico.is_manuale_residenza == 0"
                                                         outlined
                                                         :rules="!isEmpatikAdmin() ? [rules.required] : []"
                                                         @input="setTecnicoCampoModificato('comune_residenza')"
                                                   >
                                                         <template v-slot:append>
                                                            <LockIcon v-if="tecnico.is_manuale_residenza == 0" class="my-auto !h-5 !w-5 cursor-not-allowed" />
                                                            <v-tooltip v-if="tecnico.id != null && tecnicoCampiModificati['comune_residenza']" bottom>
                                                               <template v-slot:activator="{ on, attrs }">
                                                                     <span v-bind="attrs" v-on="on">
                                                                        <EditingIcon class="my-auto !h-5 !w-5 !text-yellow-500" />
                                                                     </span>
                                                               </template>
                                                               <span>Modifica non ancora salvata</span>
                                                            </v-tooltip>
                                                            <v-icon>
                                                               mdi-chevron-down
                                                            </v-icon>
                                                         </template>
                                                   </v-select>
                                                   <!-- Text field per altre nazioni -->
                                                   <v-text-field
                                                         v-else
                                                         label="Città"
                                                         v-model="tecnico.comune_residenza"
                                                         :readonly="tecnico.is_manuale_residenza == 0"
                                                         :disabled="tecnico.is_manuale_residenza == 0"
                                                         outlined
                                                         :rules="!isEmpatikAdmin() ? [rules.required] : []"
                                                         @input="setTecnicoCampoModificato('comune_residenza')"
                                                   >
                                                         <template v-slot:append>
                                                            <LockIcon v-if="tecnico.is_manuale_residenza == 0" class="my-auto !h-5 !w-5 cursor-not-allowed" />
                                                            <v-tooltip v-if="tecnico.id != null && tecnicoCampiModificati['comune_residenza']" bottom>
                                                               <template v-slot:activator="{ on, attrs }">
                                                                     <span v-bind="attrs" v-on="on">
                                                                        <EditingIcon class="my-auto !h-5 !w-5 !text-yellow-500" />
                                                                     </span>
                                                               </template>
                                                               <span>Modifica non ancora salvata</span>
                                                            </v-tooltip>
                                                         </template>
                                                   </v-text-field>
                                                </v-col>
                                                <v-col cols="12" md="6">
                                                   <!-- Select per Italia -->
                                                   <v-select
                                                         v-if="tecnico.nazione_residenza === 'ITALIA'"
                                                         :items="capsByComuneResidenza"
                                                         item-text="codice"
                                                         item-value="codice"
                                                         label="CAP"
                                                         v-model="tecnico.cap_residenza"
                                                         :readonly="tecnico.is_manuale_residenza == 0"
                                                         :disabled="tecnico.is_manuale_residenza == 0"
                                                         outlined
                                                         :rules="!isEmpatikAdmin() ? [rules.required] : []"
                                                         @input="setTecnicoCampoModificato('cap_residenza')"
                                                   >
                                                         <template v-slot:append>
                                                            <LockIcon v-if="tecnico.is_manuale_residenza == 0" class="my-auto !h-5 !w-5 cursor-not-allowed" />
                                                            <v-tooltip v-if="tecnico.id != null && tecnicoCampiModificati['cap_residenza']" bottom>
                                                               <template v-slot:activator="{ on, attrs }">
                                                                     <span v-bind="attrs" v-on="on">
                                                                        <EditingIcon class="my-auto !h-5 !w-5 !text-yellow-500" />
                                                                     </span>
                                                               </template>
                                                               <span>Modifica non ancora salvata</span>
                                                            </v-tooltip>
                                                            <v-icon>
                                                               mdi-chevron-down
                                                            </v-icon>
                                                         </template>
                                                   </v-select>
                                                   <!-- Text field per altre nazioni -->
                                                   <v-text-field
                                                         v-else
                                                         label="CAP / Codice Postale"
                                                         v-model="tecnico.cap_residenza"
                                                         :readonly="tecnico.is_manuale_residenza == 0"
                                                         :disabled="tecnico.is_manuale_residenza == 0"
                                                         outlined
                                                         :rules="!isEmpatikAdmin() ? [rules.required] : []"
                                                         @input="setTecnicoCampoModificato('cap_residenza')"
                                                   >
                                                         <template v-slot:append>
                                                            <LockIcon v-if="tecnico.is_manuale_residenza == 0" class="my-auto !h-5 !w-5 cursor-not-allowed" />
                                                            <v-tooltip v-if="tecnico.id != null && tecnicoCampiModificati['cap_residenza']" bottom>
                                                               <template v-slot:activator="{ on, attrs }">
                                                                     <span v-bind="attrs" v-on="on">
                                                                        <EditingIcon class="my-auto !h-5 !w-5 !text-yellow-500" />
                                                                     </span>
                                                               </template>
                                                               <span>Modifica non ancora salvata</span>
                                                            </v-tooltip>
                                                         </template>
                                                   </v-text-field>
                                                </v-col>
                                             </v-row>
                                       </div>
                                       <v-divider class="mb-6 mt-0"></v-divider>
                                       <!-- Sezione Indirizzo di Domicilio -->
                                       <div>
                                             <h2 class="text-xl font-bold mb-4 text-csenBlue-950 dark:text-csenBlue-200">Indirizzo di domicilio</h2>
                                             <v-row dense>
                                                <v-col cols="12" md="6" class="mb-4">
                                                   <v-btn @click="copiaResidenzaInDomicilio" class="!text-csenBlue-700 !bg-csenBlue-50 dark:!text-white dark:!bg-csenBlue-700 !tracking-wide mr-3">
                                                         <v-icon left>mdi-content-copy</v-icon>
                                                         Copia indirizzo di residenza
                                                   </v-btn>
                                                </v-col>
                                             </v-row>
                                             <div>
                                                <v-autocomplete
                                                   v-model="domicilioSelected"
                                                   autocomplete="none"
                                                   :items="domicilioOptions"
                                                   :search-input.sync="domicilioSearchText"
                                                   :loading="isLoadingDomicilioSearch"
                                                   label="Cerca indirizzo domicilio"
                                                   placeholder="Inizia a scrivere per cercare.."
                                                   open-on-focus
                                                   hide-no-data
                                                   outlined
                                                   class="!z-10"
                                                   no-filter
                                                   item-text="nomeDaMostrare"
                                                   return-object
                                                   :disabled="tecnico.is_manuale_domicilio == 1"
                                                ></v-autocomplete>
                                                <v-switch
                                                   label="Inserisci manualmente"
                                                   v-model="tecnico.is_manuale_domicilio"
                                                   class="!-mt-3"
                                                ></v-switch>
                                             </div>
                                             <v-row dense>
                                                <!-- Via / Piazza -->
                                                <v-col cols="12" md="5">
                                                   <v-text-field
                                                         label="Via / Piazza"
                                                         v-model="tecnico.indirizzo_domicilio"
                                                         :readonly="tecnico.is_manuale_domicilio == 0"
                                                         :disabled="tecnico.is_manuale_domicilio == 0"
                                                         outlined
                                                         @input="setTecnicoCampoModificato('indirizzo_domicilio')"
                                                   >
                                                         <template v-slot:append>
                                                            <LockIcon v-if="tecnico.is_manuale_domicilio == 0" class="my-auto !h-5 !w-5 cursor-not-allowed" />
                                                            <v-tooltip v-if="tecnico.id != null && tecnicoCampiModificati['indirizzo_domicilio']" bottom>
                                                               <template v-slot:activator="{ on, attrs }">
                                                                     <span v-bind="attrs" v-on="on">
                                                                        <EditingIcon class="my-auto !h-5 !w-5 !text-yellow-500" />
                                                                     </span>
                                                               </template>
                                                               <span>Modifica non ancora salvata</span>
                                                            </v-tooltip>
                                                         </template>
                                                   </v-text-field>
                                                </v-col>
                                                <!-- Numero Civico -->
                                                <v-col cols="12" md="4">
                                                   <v-text-field
                                                         label="Civico e altri dettagli"
                                                         v-model="tecnico.civico_domicilio"
                                                         outlined
                                                         :readonly="tecnico.is_snc_domicilio == 1 || tecnico.is_manuale_domicilio == 0"
                                                         :disabled="tecnico.is_snc_domicilio == 1 || tecnico.is_manuale_domicilio == 0"
                                                         :rules="[rules.numero_civico]"
                                                         @input="setTecnicoCampoModificato('numero_civico')"
                                                   >
                                                         <template v-slot:append>
                                                            <LockIcon v-if="(tecnico.is_snc_domicilio == 1 || tecnico.is_manuale_domicilio == 0)" class="my-auto !h-5 !w-5 cursor-not-allowed" />
                                                            <v-tooltip v-if="tecnico.id != null && tecnicoCampiModificati['numero_civico']" bottom>
                                                               <template v-slot:activator="{ on, attrs }">
                                                                     <span v-bind="attrs" v-on="on">
                                                                        <EditingIcon class="my-auto !h-5 !w-5 !text-yellow-500" />
                                                                     </span>
                                                               </template>
                                                               <span>Modifica non ancora salvata</span>
                                                            </v-tooltip>
                                                         </template>
                                                   </v-text-field>
                                                </v-col>
                                                <!-- SNC -->
                                                <v-col cols="12" md="3" class="flex items-center">
                                                   <v-switch
                                                         label="SNC = Senza Numero Civico"
                                                         v-model="tecnico.is_snc_domicilio"
                                                         :disabled="tecnico.is_manuale_domicilio == 0"
                                                         class="!-mt-3"
                                                         @input="setTecnicoCampoModificato('numero_civico')"
                                                   ></v-switch>
                                                </v-col>
                                             </v-row>
                                             <!-- Nazione, Provincia, Città, Cap DOMICILIO -->
                                             <v-row dense>
                                                <v-col cols="12" md="6">
                                                   <v-autocomplete
                                                         v-model="tecnico.nazione_domicilio"
                                                         :items="nazioni"
                                                         item-value="nome"
                                                         item-text="nome"
                                                         label="Nazione"
                                                         :readonly="tecnico.is_manuale_domicilio == 0"
                                                         :disabled="tecnico.is_manuale_domicilio == 0"
                                                         outlined
                                                         @input="setTecnicoCampoModificato('nazione_domicilio')"
                                                   >
                                                         <template v-slot:append>
                                                            <LockIcon v-if="tecnico.is_manuale_domicilio == 0" class="my-auto !h-5 !w-5 cursor-not-allowed" />
                                                            <v-tooltip v-if="tecnico.id != null && tecnicoCampiModificati['nazione_domicilio']" bottom>
                                                               <template v-slot:activator="{ on, attrs }">
                                                                     <span v-bind="attrs" v-on="on">
                                                                        <EditingIcon class="my-auto !h-5 !w-5 !text-yellow-500" />
                                                                     </span>
                                                               </template>
                                                               <span>Modifica non ancora salvata</span>
                                                            </v-tooltip>
                                                            <v-icon>
                                                               mdi-chevron-down
                                                            </v-icon>
                                                         </template>
                                                   </v-autocomplete>
                                                </v-col>
                                                <!-- PROVINCIA DOMICILIO-->
                                                <v-col cols="12" md="6">
                                                   <!-- Select per Italia -->
                                                   <v-select
                                                         v-if="tecnico.nazione_domicilio === 'ITALIA'"
                                                         :items="province"
                                                         item-value="sigla"
                                                         item-text="nome"
                                                         label="Provincia"
                                                         v-model="tecnico.sigla_provincia_domicilio"
                                                         :readonly="tecnico.is_manuale_domicilio == 0"
                                                         :disabled="tecnico.is_manuale_domicilio == 0"
                                                         outlined
                                                         @input="setTecnicoCampoModificato('sigla_provincia_domicilio')"
                                                   >
                                                         <template v-slot:append>
                                                            <LockIcon v-if="tecnico.is_manuale_domicilio == 0" class="my-auto !h-5 !w-5 cursor-not-allowed" />
                                                            <v-tooltip v-if="tecnico.id != null && tecnicoCampiModificati['sigla_provincia_domicilio']" bottom>
                                                               <template v-slot:activator="{ on, attrs }">
                                                                     <span v-bind="attrs" v-on="on">
                                                                        <EditingIcon class="my-auto !h-5 !w-5 !text-yellow-500" />
                                                                     </span>
                                                               </template>
                                                               <span>Modifica non ancora salvata</span>
                                                            </v-tooltip>
                                                            <v-icon>
                                                               mdi-chevron-down
                                                            </v-icon>
                                                         </template>
                                                   </v-select>
                                                   <!-- Text field per altre nazioni -->
                                                   <v-text-field
                                                         v-else
                                                         label="Provincia / Stato"
                                                         v-model="tecnico.sigla_provincia_domicilio"
                                                         :readonly="tecnico.is_manuale_domicilio == 0"
                                                         :disabled="tecnico.is_manuale_domicilio == 0"
                                                         outlined
                                                         @input="setTecnicoCampoModificato('sigla_provincia_domicilio')"
                                                   >
                                                         <template v-slot:append>
                                                            <LockIcon v-if="tecnico.is_manuale_domicilio == 0" class="my-auto !h-5 !w-5 cursor-not-allowed" />
                                                            <v-tooltip v-if="tecnico.id != null && tecnicoCampiModificati['sigla_provincia_domicilio']" bottom>
                                                               <template v-slot:activator="{ on, attrs }">
                                                                     <span v-bind="attrs" v-on="on">
                                                                        <EditingIcon class="my-auto !h-5 !w-5 !text-yellow-500" />
                                                                     </span>
                                                               </template>
                                                               <span>Modifica non ancora salvata</span>
                                                            </v-tooltip>
                                                         </template>
                                                   </v-text-field>
                                                </v-col>
                                                <!-- CITTA' DOMICILIO -->
                                                <v-col cols="12" md="6">
                                                   <!-- Select per Italia -->
                                                   <v-select
                                                         v-if="tecnico.nazione_domicilio === 'ITALIA'"
                                                         :items="comuniByProvinciaDomicilio"
                                                         item-value="nome"
                                                         item-text="nome"
                                                         label="Città"
                                                         v-model="tecnico.comune_domicilio"
                                                         :readonly="tecnico.is_manuale_domicilio == 0"
                                                         :disabled="tecnico.is_manuale_domicilio == 0"
                                                         outlined
                                                         @input="setTecnicoCampoModificato('comune_domicilio')"
                                                   >
                                                         <template v-slot:append>
                                                            <LockIcon v-if="tecnico.is_manuale_domicilio == 0" class="my-auto !h-5 !w-5 cursor-not-allowed" />
                                                            <v-tooltip v-if="tecnico.id != null && tecnicoCampiModificati['comune_domicilio']" bottom>
                                                               <template v-slot:activator="{ on, attrs }">
                                                                     <span v-bind="attrs" v-on="on">
                                                                        <EditingIcon class="my-auto !h-5 !w-5 !text-yellow-500" />
                                                                     </span>
                                                               </template>
                                                               <span>Modifica non ancora salvata</span>
                                                            </v-tooltip>
                                                            <v-icon>
                                                               mdi-chevron-down
                                                            </v-icon>
                                                         </template>
                                                   </v-select>
                                                   <!-- Text field per altre nazioni -->
                                                   <v-text-field
                                                         v-else
                                                         label="Città"
                                                         v-model="tecnico.comune_domicilio"
                                                         :readonly="tecnico.is_manuale_domicilio == 0"
                                                         :disabled="tecnico.is_manuale_domicilio == 0"
                                                         outlined
                                                         @input="setTecnicoCampoModificato('comune_domicilio')"
                                                   >
                                                         <template v-slot:append>
                                                            <LockIcon v-if="tecnico.is_manuale_domicilio == 0" class="my-auto !h-5 !w-5 cursor-not-allowed" />
                                                            <v-tooltip v-if="tecnico.id != null && tecnicoCampiModificati['comune_domicilio']" bottom>
                                                               <template v-slot:activator="{ on, attrs }">
                                                                     <span v-bind="attrs" v-on="on">
                                                                        <EditingIcon class="my-auto !h-5 !w-5 !text-yellow-500" />
                                                                     </span>
                                                               </template>
                                                               <span>Modifica non ancora salvata</span>
                                                            </v-tooltip>
                                                         </template>
                                                   </v-text-field>
                                                </v-col>
                                                <!-- CAP DOMICILIO-->
                                                <v-col cols="12" md="6">
                                                   <!-- Select per Italia -->
                                                   <v-select
                                                         v-if="tecnico.nazione_domicilio === 'ITALIA'"
                                                         :items="capsByComuneDomicilio"
                                                         item-text="codice"
                                                         item-value="codice"
                                                         label="CAP"
                                                         v-model="tecnico.cap_domicilio"
                                                         :readonly="tecnico.is_manuale_domicilio == 0"
                                                         :disabled="tecnico.is_manuale_domicilio == 0"
                                                         outlined
                                                         @input="setTecnicoCampoModificato('cap_domicilio')"
                                                   >
                                                         <template v-slot:append>
                                                            <LockIcon v-if="tecnico.is_manuale_domicilio == 0" class="my-auto !h-5 !w-5 cursor-not-allowed" />
                                                            <v-tooltip v-if="tecnico.id != null && tecnicoCampiModificati['cap_domicilio']" bottom>
                                                               <template v-slot:activator="{ on, attrs }">
                                                                     <span v-bind="attrs" v-on="on">
                                                                        <EditingIcon class="my-auto !h-5 !w-5 !text-yellow-500" />
                                                                     </span>
                                                               </template>
                                                               <span>Modifica non ancora salvata</span>
                                                            </v-tooltip>
                                                            <v-icon>
                                                               mdi-chevron-down
                                                            </v-icon>
                                                         </template>
                                                   </v-select>
                                                   <!-- Text field per altre nazioni -->
                                                   <v-text-field
                                                         v-else
                                                         label="CAP / Codice Postale"
                                                         v-model="tecnico.cap_domicilio"
                                                         :readonly="tecnico.is_manuale_domicilio == 0"
                                                         :disabled="tecnico.is_manuale_domicilio == 0"
                                                         outlined
                                                         @input="setTecnicoCampoModificato('cap_domicilio')"
                                                   >
                                                         <template v-slot:append>
                                                            <LockIcon v-if="tecnico.is_manuale_domicilio == 0" class="my-auto !h-5 !w-5 cursor-not-allowed" />
                                                            <v-tooltip v-if="tecnico.id != null && tecnicoCampiModificati['cap_domicilio']" bottom>
                                                               <template v-slot:activator="{ on, attrs }">
                                                                     <span v-bind="attrs" v-on="on">
                                                                        <EditingIcon class="my-auto !h-5 !w-5 !text-yellow-500" />
                                                                     </span>
                                                               </template>
                                                               <span>Modifica non ancora salvata</span>
                                                            </v-tooltip>
                                                         </template>
                                                   </v-text-field>
                                                </v-col>
                                             </v-row>
                                       </div>
                                       <v-divider></v-divider>
                                       <!-- Sezione Indirizzo di Spedizione -->
                                       <div>
                                             <h2 class="text-xl font-bold mt-4 mb-4 text-csenBlue-950 dark:text-csenBlue-200 ">Indirizzo di spedizione</h2>
                                             <v-row dense>
                                                <v-col cols="12" md="6" class="block sm:flex mb-4">
                                                   <v-btn class="!text-csenBlue-700 !bg-csenBlue-50 my-1 dark:!text-white dark:!bg-csenBlue-700 !tracking-wide sm:mr-3" @click="copiaResidenzaInSpedizione">
                                                         <v-icon left>mdi-content-copy</v-icon>
                                                         Copia indirizzo di residenza
                                                   </v-btn>
                                                   <v-btn class="!text-csenBlue-700 !bg-csenBlue-50 my-1 dark:!text-white dark:!bg-csenBlue-700 !tracking-wide sm:mr-3" @click="copiaDomicilioInSpedizione">
                                                         <v-icon left>mdi-content-copy</v-icon>
                                                         Copia indirizzo di domicilio
                                                   </v-btn>
                                                </v-col>
                                             </v-row>
                                             <div>
                                                <v-autocomplete
                                                   v-model="spedizioneSelected"
                                                   autocomplete="none"
                                                   :items="spedizioneOptions"
                                                   :search-input.sync="spedizioneSearchText"
                                                   :loading="isLoadingSpedizioneSearch"
                                                   label="Cerca indirizzo spedizione"
                                                   placeholder="Inizia a scrivere per cercare.."
                                                   open-on-focus
                                                   hide-no-data
                                                   outlined
                                                   class="!z-10"
                                                   no-filter
                                                   item-text="nomeDaMostrare"
                                                   return-object
                                                   :disabled="tecnico.is_manuale_spedizione == 1"
                                                ></v-autocomplete>
                                                <v-switch
                                                   label=" Inserisci manualmente"
                                                   v-model="tecnico.is_manuale_spedizione"
                                                   class="!-mt-3"
                                                ></v-switch>
                                             </div>
                                             <v-row dense>
                                                <!-- Via / Piazza -->
                                                <v-col cols="12" md="5">
                                                   <v-text-field
                                                         label="Via / Piazza"
                                                         v-model="tecnico.indirizzo_spedizione"
                                                         :readonly="tecnico.is_manuale_spedizione == 0"
                                                         :disabled="tecnico.is_manuale_spedizione == 0"
                                                         outlined
                                                         @input="setTecnicoCampoModificato('indirizzo_spedizione')"
                                                   >
                                                         <template v-slot:append>
                                                            <LockIcon v-if="tecnico.is_manuale_spedizione == 0" class="my-auto !h-5 !w-5 cursor-not-allowed" />
                                                            <v-tooltip v-if="tecnico.id != null && tecnicoCampiModificati['indirizzo_spedizione']" bottom>
                                                               <template v-slot:activator="{ on, attrs }">
                                                                     <span v-bind="attrs" v-on="on">
                                                                        <EditingIcon class="my-auto !h-5 !w-5 !text-yellow-500" />
                                                                     </span>
                                                               </template>
                                                               <span>Modifica non ancora salvata</span>
                                                            </v-tooltip>
                                                            
                                                         </template>
                                                   </v-text-field>
                                                </v-col>
                                                <!-- Numero Civico -->
                                                <v-col cols="12" md="4">
                                                   <v-text-field
                                                         label="Civico e altri dettagli"
                                                         v-model="tecnico.civico_spedizione"
                                                         outlined
                                                         :readonly="tecnico.is_snc_spedizione == 1 || tecnico.is_manuale_spedizione == 0"
                                                         :disabled="tecnico.is_snc_spedizione == 1 || tecnico.is_manuale_spedizione == 0"
                                                         :rules="[rules.numero_civico]"
                                                         @input="setTecnicoCampoModificato('civico_spedizione')"
                                                   >
                                                         <template v-slot:append>
                                                            <LockIcon v-if="(tecnico.is_snc_spedizione == 1 || tecnico.is_manuale_spedizione == 0)" class="my-auto !h-5 !w-5 cursor-not-allowed" />
                                                            <v-tooltip v-if="tecnico.id != null && tecnicoCampiModificati['civico_spedizione']" bottom>
                                                               <template v-slot:activator="{ on, attrs }">
                                                                     <span v-bind="attrs" v-on="on">
                                                                        <EditingIcon class="my-auto !h-5 !w-5 !text-yellow-500" />
                                                                     </span>
                                                               </template>
                                                               <span>Modifica non ancora salvata</span>
                                                            </v-tooltip>
                                                         </template>
                                                   </v-text-field>
                                                </v-col>
                                                <!-- SNC -->
                                                <v-col cols="12" md="3" class="flex items-center">
                                                   <v-switch
                                                         label="SNC = Senza Numero Civico"
                                                         v-model="tecnico.is_snc_spedizione"
                                                         :disabled="tecnico.is_manuale_spedizione == 0"
                                                         class="!-mt-3"
                                                         @input="setTecnicoCampoModificato('civico_spedizione')"
                                                   ></v-switch>
                                                </v-col>
                                             </v-row>
                                             <!-- Nazione, Provincia, Città, Cap SPEDIZIONE -->
                                             <v-row dense>
                                                <v-col cols="12" md="6">
                                                   <v-autocomplete
                                                         v-model="tecnico.nazione_spedizione"
                                                         :items="nazioni"
                                                         item-value="nome"
                                                         item-text="nome"
                                                         label="Nazione"
                                                         :readonly="tecnico.is_manuale_spedizione == 0"
                                                         :disabled="tecnico.is_manuale_spedizione == 0"
                                                         outlined
                                                         @input="setTecnicoCampoModificato('nazione_spedizione')"
                                                   >
                                                         <template v-slot:append>
                                                            <LockIcon v-if="tecnico.is_manuale_spedizione == 0" class="my-auto !h-5 !w-5 cursor-not-allowed" />
                                                            <v-tooltip v-if="tecnico.id != null && tecnicoCampiModificati['nazione_spedizione']" bottom>
                                                               <template v-slot:activator="{ on, attrs }">
                                                                     <span v-bind="attrs" v-on="on">
                                                                        <EditingIcon class="my-auto !h-5 !w-5 !text-yellow-500" />
                                                                     </span>
                                                               </template>
                                                               <span>Modifica non ancora salvata</span>
                                                            </v-tooltip>
                                                            <v-icon>
                                                               mdi-chevron-down
                                                            </v-icon>
                                                         </template>
                                                   </v-autocomplete>
                                                </v-col>
                                                <v-col cols="12" md="6">
                                                   <!-- Select per Italia -->
                                                   <v-select
                                                         v-if="tecnico.nazione_spedizione === 'ITALIA'"
                                                         :items="province"
                                                         item-value="sigla"
                                                         item-text="nome"
                                                         label="Provincia"
                                                         v-model="tecnico.sigla_provincia_spedizione"
                                                         :readonly="tecnico.is_manuale_spedizione == 0"
                                                         :disabled="tecnico.is_manuale_spedizione == 0"
                                                         outlined
                                                         @input="setTecnicoCampoModificato('sigla_provincia_spedizione')"
                                                   >
                                                         <template v-slot:append>
                                                            <LockIcon v-if="tecnico.is_manuale_spedizione == 0" class="my-auto !h-5 !w-5 cursor-not-allowed" />
                                                            <v-tooltip v-if="tecnico.id != null && tecnicoCampiModificati['sigla_provincia_spedizione']" bottom>
                                                               <template v-slot:activator="{ on, attrs }">
                                                                     <span v-bind="attrs" v-on="on">
                                                                        <EditingIcon class="my-auto !h-5 !w-5 !text-yellow-500" />
                                                                     </span>
                                                               </template>
                                                               <span>Modifica non ancora salvata</span>
                                                            </v-tooltip>
                                                            <v-icon>
                                                               mdi-chevron-down
                                                            </v-icon>
                                                         </template>
                                                   </v-select>
                                                   <!-- Text field per altre nazioni -->
                                                   <v-text-field
                                                         v-else
                                                         label="Provincia / Stato"
                                                         v-model="tecnico.sigla_provincia_spedizione"
                                                         :readonly="tecnico.is_manuale_spedizione == 0"
                                                         :disabled="tecnico.is_manuale_spedizione == 0"
                                                         outlined
                                                         @input="setTecnicoCampoModificato('sigla_provincia_spedizione')"
                                                   >
                                                         <template v-slot:append>
                                                            <LockIcon v-if="tecnico.is_manuale_spedizione == 0" class="my-auto !h-5 !w-5 cursor-not-allowed" />
                                                            <v-tooltip v-if="tecnico.id != null && tecnicoCampiModificati['sigla_provincia_spedizione']" bottom>
                                                               <template v-slot:activator="{ on, attrs }">
                                                                     <span v-bind="attrs" v-on="on">
                                                                        <EditingIcon class="my-auto !h-5 !w-5 !text-yellow-500" />
                                                                     </span>
                                                               </template>
                                                               <span>Modifica non ancora salvata</span>
                                                            </v-tooltip>
                                                         </template>
                                                   </v-text-field>
                                                </v-col>
                                                <v-col cols="12" md="6">
                                                   <!-- Select per Italia -->
                                                   <v-select
                                                         v-if="tecnico.nazione_spedizione === 'ITALIA'"
                                                         :items="comuniByProvinciaSpedizione"
                                                         item-value="nome"
                                                         item-text="nome"
                                                         label="Città"
                                                         v-model="tecnico.comune_spedizione"
                                                         :readonly="tecnico.is_manuale_spedizione == 0"
                                                         :disabled="tecnico.is_manuale_spedizione == 0"
                                                         outlined
                                                         @input="setTecnicoCampoModificato('comune_spedizione')"
                                                   >
                                                         <template v-slot:append>
                                                            <LockIcon v-if="tecnico.is_manuale_spedizione == 0" class="my-auto !h-5 !w-5 cursor-not-allowed" />
                                                            <v-tooltip v-if="tecnico.id != null && tecnicoCampiModificati['comune_spedizione']" bottom>
                                                               <template v-slot:activator="{ on, attrs }">
                                                                     <span v-bind="attrs" v-on="on">
                                                                        <EditingIcon class="my-auto !h-5 !w-5 !text-yellow-500" />
                                                                     </span>
                                                               </template>
                                                               <span>Modifica non ancora salvata</span>
                                                            </v-tooltip>
                                                            <v-icon>
                                                               mdi-chevron-down
                                                            </v-icon>
                                                         </template>
                                                   </v-select>
                                                   <!-- Text field per altre nazioni -->
                                                   <v-text-field
                                                         v-else
                                                         label="Città"
                                                         v-model="tecnico.comune_spedizione"
                                                         :readonly="tecnico.is_manuale_spedizione == 0"
                                                         :disabled="tecnico.is_manuale_spedizione == 0"
                                                         outlined
                                                         @input="setTecnicoCampoModificato('comune_spedizione')"
                                                   >
                                                         <template v-slot:append>
                                                            <LockIcon v-if="tecnico.is_manuale_spedizione == 0" class="my-auto !h-5 !w-5 cursor-not-allowed" />
                                                            <v-tooltip v-if="tecnico.id != null && tecnicoCampiModificati['comune_spedizione']" bottom>
                                                               <template v-slot:activator="{ on, attrs }">
                                                                     <span v-bind="attrs" v-on="on">
                                                                        <EditingIcon class="my-auto !h-5 !w-5 !text-yellow-500" />
                                                                     </span>
                                                               </template>
                                                               <span>Modifica non ancora salvata</span>
                                                            </v-tooltip>
                                                         </template>
                                                   </v-text-field>
                                                </v-col>
                                                <v-col cols="12" md="6">
                                                   <!-- Select per Italia -->
                                                   <v-select
                                                         v-if="tecnico.nazione_spedizione === 'ITALIA'"
                                                         :items="capsByComuneSpedizione"
                                                         item-text="codice"
                                                         item-value="codice"
                                                         label="CAP"
                                                         v-model="tecnico.cap_spedizione"
                                                         :readonly="tecnico.is_manuale_spedizione == 0"
                                                         :disabled="tecnico.is_manuale_spedizione == 0"
                                                         outlined
                                                         @input="setTecnicoCampoModificato('cap_spedizione')"
                                                   >
                                                         <template v-slot:append>
                                                            <LockIcon v-if="tecnico.is_manuale_spedizione == 0" class="my-auto !h-5 !w-5 cursor-not-allowed" />
                                                            <v-tooltip v-if="tecnico.id != null && tecnicoCampiModificati['cap_spedizione']" bottom>
                                                               <template v-slot:activator="{ on, attrs }">
                                                                     <span v-bind="attrs" v-on="on">
                                                                        <EditingIcon class="my-auto !h-5 !w-5 !text-yellow-500" />
                                                                     </span>
                                                               </template>
                                                               <span>Modifica non ancora salvata</span>
                                                            </v-tooltip>
                                                            <v-icon>
                                                               mdi-chevron-down
                                                            </v-icon>
                                                         </template>
                                                   </v-select>
                                                   <!-- Text field per altre nazioni -->
                                                   <v-text-field
                                                         v-else
                                                         label="CAP / Codice Postale"
                                                         v-model="tecnico.cap_spedizione"
                                                         :readonly="tecnico.is_manuale_spedizione == 0"
                                                         :disabled="tecnico.is_manuale_spedizione == 0"
                                                         outlined
                                                         @input="setTecnicoCampoModificato('cap_spedizione')"
                                                   >
                                                         <template v-slot:append>
                                                            <LockIcon v-if="tecnico.is_manuale_spedizione == 0" class="my-auto !h-5 !w-5 cursor-not-allowed" />
                                                            <v-tooltip v-if="tecnico.id != null && tecnicoCampiModificati['cap_spedizione']" bottom>
                                                               <template v-slot:activator="{ on, attrs }">
                                                                     <span v-bind="attrs" v-on="on">
                                                                        <EditingIcon class="my-auto !h-5 !w-5 !text-yellow-500" />
                                                                     </span>
                                                               </template>
                                                               <span>Modifica non ancora salvata</span>
                                                            </v-tooltip>
                                                         </template>
                                                   </v-text-field>
                                                </v-col>
                                             </v-row>
                                             <v-row dense>
                                                <v-text-field
                                                   label="Presso..."
                                                   v-model="tecnico.presso_spedizione"
                                                   outlined
                                                   type="text"
                                                   @input="setTecnicoCampoModificato('presso_spedizione')"
                                                >
                                                   <template v-slot:append>
                                                         <v-tooltip v-if="tecnico.id != null && tecnicoCampiModificati['presso_spedizione']" bottom>
                                                            <template v-slot:activator="{ on, attrs }">
                                                               <span v-bind="attrs" v-on="on">
                                                                     <EditingIcon class="my-auto !h-5 !w-5 !text-yellow-500" />
                                                               </span>
                                                            </template>
                                                            <span>Modifica non ancora salvata</span>
                                                         </v-tooltip>
                                                   </template>
                                                </v-text-field>
                                             </v-row>
                                       </div>
                                       <v-divider></v-divider>
                           </v-card>
                        </v-tab-item>

                        
                        <!-- FINE TAB INDIRIZZI -->
                        

                     <!-- TAB DIPLOMI -->
                     <v-tab-item>
                        <v-card flat class="p-9 dark:!bg-csenBlue-900 w-full !rounded-none !ring-0 !border-0">
                                 <!-- VISIBILE SOLO DA ADMIN v-if="loggedAs.ruolo=='admin'" -->
                                 <div v-if="loggedAs.ruolo=='admin'" class="w-full">
                                    <!-- ALERT SALVA IL TECNICO -->
                                    <div class="sm:flex justify-between p-2 mb-6 my-auto font-medium rounded-md  bg-csenOrange-100" 
                                       v-if="tecnico.id == null">
                                       <div class="inline-flex my-auto text-sm pl-3 text-csenOrange-600">
                                          <WarningIcon class="h-5 w-5 my-auto"></WarningIcon>  
                                          <span class="ml-2 my-auto">Per inserire diplomi devi prima creare il nuovo tecnico: </span>
                                       </div>
                                       <div class="my-auto">
                                          <v-btn id="diplomi-crea-tecnico" v-if="tecnico.id == null" @click="aggiungiTecnicoSenzaChiudereDialog(3)" class="!bg-csenGreen-500 !text-white !tracking-normal !py-5 ">
                                             <PersonAddIcon class="text-csenGreen-100 mr-2"></PersonAddIcon>
                                             Crea nuovo Tecnico
                                          </v-btn>
                                       </div>
                                    </div>
                                 </div>
                                 <!-- Testo iniziale -->
                                 <div id="AnchorDiplomi">
                                    <div class="flex justify-between">
                                       <!-- TITOLO X ADMIN -->
                                       <div v-if="loggedAs.ruolo == 'admin'"  id="AnchorDiploma">
                                          <h2 class="text-xl font-bold text-csenBlue-950 dark:text-csenBlue-200 ">Diplomi</h2>
                                          <p class="py-1 text-sm">Tabella che mostra i diplomi ottenuti dal tecnico.</p>
                                       </div>  
                                       <!-- TITOLO X TECNICI -->
                                       <div v-else id="AnchorDiploma">
                                          <h2 class="text-xl font-bold text-csenBlue-950 dark:text-csenBlue-200 ">I tuoi Diplomi</h2>
                                          <p class="py-1 text-sm">Quando consegui una qualifica, il <strong>Diploma Nazionale insieme al Patentino o all’etichetta di aggiornamento</strong> (se sei già in possesso del Patentino CSEN), ti verranno inviati tramite corriere GLS al tuo indirizzo di spedizione <strong>entro 30 giorni dal superamento dell'esame</strong>. 
                                             Inoltre, <strong>entro 60 giorni</strong> la tua qualifica verrà inserita in questa sezione e sarà visibile nell'elenco dell'albo e, se sportiva, sarà trasmessa anche al RASD (registro di legge).</p>
                                       </div>  
                                    
                                       <!-- AGGIUNGI DIPLOMA --> 
                                       <div v-if="loggedAs.ruolo == 'admin'" class="flex justify-end my-auto">
                                          <v-btn :disabled="tecnico.id == null" @click="openDiplomaDialog()" class=" !bg-csenBlue-900 dark:!bg-csenBlue-600 !text-white !tracking-normal !py-5 mb-4 ">
                                             <PlusIcon class="text-csenBlue-300 mr-2"></PlusIcon>
                                             <span>Aggiungi diploma</span>
                                          </v-btn>
                                       </div>
                                    </div>
                                 </div>
                           
                           <!-- Tabella Diplomi -->
                           <v-data-table
                              :headers="headersDiplomiComputed"
                              :items="tecnico.diplomi"
                              class=""
                              disable-sort
                              :footer-props="{itemsPerPageText: 'Diplomi per pagina'}"
                              >
                              <template v-slot:item.nome_corso="{ item }">
                                 <div class="text-left font-semibold">
                                    {{ item.nome_corso }}
                                 </div>
                              </template>
                              <!-- Data di conseguimento --> 
                              <template v-slot:item.data_conseguimento="{ item }">
                                 <div class="text-left">
                                    {{ formattaData(item.data_conseguimento) }}
                                 </div>
                                 <!-- Edizione corso --> 
                              </template>
                              <template v-slot:item.nome_edizione="{ item }">
                                 <div class="text-left">
                                    {{ item.nome_edizione }}
                                 </div>
                              </template>
                              <!-- Azioni -->
                              <!-- VISIBILE SOLO DA ADMIN v-if="loggedAs.ruolo=='admin'" -->
                              <template v-if="loggedAs.ruolo == 'admin'" v-slot:item.azioni="{ item }">
                                 <div class="flex justify-left gap-x-1">
                                    <button type="button" @click="openDiplomaDialog(item)"
                                       class="bg-csenOrange-100 !text-csenOrange-500 dark:!text-white dark:bg-csenOrange-500 inline-flex justify-center content-center px-auto rounded-md hover:bg-csenOrange-500 hover:!text-white transition w-9 h-9" 
                                       title="Modifica Diploma"
                                       >
                                       <EditIcon class="my-auto"></EditIcon>
                                    </button>
                                    <button type="button" @click="eliminaDiploma(item)" 
                                       class="bg-red-100 !text-csenRed-500 dark:!text-white dark:bg-csenRed-500 inline-flex justify-center content-center px-auto rounded-md hover:bg-csenRed-500 hover:!text-white transition w-9 h-9" 
                                       title="Elimina Diploma"
                                       >
                                       <DeleteIcon class="my-auto"></DeleteIcon>
                                    </button>
                                 </div>
                              </template>
                              <v-pagination
                                 v-model="page"
                                 :length="pageCount"
                                 class="mt-4"
                                 ></v-pagination>
                           </v-data-table>
                           <v-divider></v-divider>
                        </v-card>
                     </v-tab-item>
                     <!-- FINE TAB DIPLOMI -->

                        <!-- TAB RINNOVI-->
                        <v-tab-item>
                           <v-card flat class="p-9 dark:!bg-csenBlue-900 w-full !rounded-none !ring-0 !border-0">
                              <div id="AnchorRinnovi" ></div>
                              <!-- FLUSSO LOGIN ADMIN -->
                                 <div v-if="loggedAs.ruolo=='admin'" class="w-full">
                                    <div>                                    <!-- ALERT SALVA IL TECNICO -->
                                       <div class="sm:flex justify-between p-2 mb-6 my-auto font-medium rounded-md  bg-csenOrange-100" 
                                          v-if="tecnico.id == null">
                                          <div class="inline-flex my-auto text-sm pl-3 text-csenOrange-600">
                                             <WarningIcon class="h-5 w-5 my-auto"></WarningIcon>  
                                             <span class="ml-2 my-auto">Per inserire rinnovi devi prima creare il nuovo tecnico: </span>
                                          </div>
                                          <div class="my-auto">
                                             <v-btn id="rinnovi-crea-tecnico" v-if="tecnico.id == null" @click="aggiungiTecnicoSenzaChiudereDialog(4)" class="!bg-csenGreen-500 !text-white !tracking-normal !py-5 ">
                                                <PersonAddIcon class="text-csenGreen-100 mr-2"></PersonAddIcon>
                                                Crea nuovo Tecnico
                                             </v-btn>
                                          </div>
                                       </div>
                                    </div>

                                    <!-- Testo iniziale -->
                                    <div class="flex justify-between">
                                       <!-- TITOLO -->
                                       <div class="pt-2 pl-2">
                                          <h2 class="text-xl font-bold text-csenBlue-950 dark:text-csenBlue-200 ">Rinnovi</h2>
                                          <p class="py-1 text-sm">Tabella che mostra i rinnovi del patentino tecnico effettuati fin ora.</p>
                                          <!-- <p class="py-1 text-sm">
                                             Il rinnovo di ogni anno vale per l'anno solare dal 01/01 al 31/12 di quell'anno.<br/>
                                             Per rinnovare clicca il pulsante Acquista Rinnovo e seleziona l'anno che vuoi rinnovare.<br/>
                                             Nella schermata successiva potrai pagare accedendo al tuo <b>account PayPal</b> oppure, se non ne hai uno, cliccando su <b>"Paga con una carta"</b> per completare il pagamento con una carta.
                                          </p> -->
                                       </div>  
                                    
                                       <!-- AGGIUNGI RINNOVO  -->
                                       <div class="flex justify-end my-auto">
                                          <v-btn :disabled="tecnico.id == null" @click="openRinnovoDialog()" class="!bg-csenBlue-900 dark:!bg-csenBlue-700 !text-white !tracking-normal !py-5">
                                          <PlusIcon class="text-csenBlue-300 mr-2"></PlusIcon>
                                          <span>Aggiungi rinnovo</span>
                                       </v-btn>
                                       </div>
                                    </div>
                                 </div>
                                
                              <!-- FLUSSO LOGIN TECNICO -->
                                 <div v-else class="flex-col mb-3 w-full">
                                    <v-row>
                                       <div class="my-auto pt-2 pl-2">
                                          <h2 class="text-xl font-bold text-csenBlue-950 dark:text-csenBlue-200">Rinnovi</h2>
                                          <p class="py-1 text-sm" v-if="(tecnico.referente_id == null || tecnico.referente.autogestisce_rinnovi == 0)">
                                             Il rinnovo vale per <b>l'anno solare</b> dal 01/01 al 31/12 e costa <b>25€</b>.<br/>
                                             Per rinnovare clicca il pulsante <b>“Acquista Rinnovo”</b>, seleziona l'anno e clicca su <b>“Acquista”</b>.<br/>
                                             Nella schermata successiva potrai pagare online in modo sicuro con carta di credito, debito o Postepay.<br/>
                                             Subito dopo il pagamento, il rinnovo sarà visibile qui e potrai stampare il bollino cliccando su <b>“Stampa Bollino”</b>.
                                          </p>
                                          <p v-else class="py-1 text-sm">Tabella che mostra i rinnovi del patentino tecnico effettuati fin ora.</p>
                                       </div>
                                       <div v-if="tecnico.referente_id == null || tecnico.referente.autogestisce_rinnovi != 1" class="my-auto flex justify-end p-2 rounded-md gap-x-2">
                                          <v-btn id="rinnovi-altri-anni" @click="openRinnovoAltriAnniDialog()" class="!bg-csenBlue-900 dark:!bg-csenBlue-700 w-full sm:!w-auto !text-white !tracking-normal !py-6">
                                             <PlusIcon class="text-csenBlue-300 mr-2"></PlusIcon>
                                             <span>Acquista rinnovo</span>
                                          </v-btn>
                                       </div>
                                    </v-row>
                                    <br/>

                                    <!-- IMPOSTIAMO QUI LA CONDIZIONE: VISIBILE QUANDO IL RINNOVO PRECEDENTE E' QUASI SCADUTO -->
                                    
                                    <!-- ATTENZIONE: messo MOMENTANEAMENTE "display:none" su if ed else, lasciando solo else-if -->
                                    <div style="display:none" v-if="isRinnovoScadutoComputed && (tecnico.referente_id == null || tecnico.referente.autogestisce_rinnovi == 0)" class="flex-col bg-csenOrange-100 border-2 border-csenOrange-600 dark:bg-csenOrange-600 border-dashed py-4 px-6 rounded-md">
                                       <div class="flex text-csenOrange-600 dark:!text-white">
                                          <WarningIcon class="hidden sm:block my-auto w-5 h-5"></WarningIcon>
                                          <span class="font-semibold my-auto sm:ml-2">Ricordati di rinnovare il tuo patentino entro la data di scadenza!</span>
                                       </div>
                                       <div class="text-csenOrange-800 dark:text-csenOrange-100 text-sm mt-2 mb-3">
                                          Rinnova per quest'anno (<strong>25€</strong>) cliccando sul pulsante qui sotto. Nella schermata successiva potrai pagare con una carta.
                                       </div>
                                       <div>
                                          <v-btn id="procedi-rinnovi" @click="pagamentoRinnovo()" class=" !bg-csenBlue-900 !text-white !tracking-normal !py-5">
                                             <OutsideLink class="text-csenBlue-300 hidden sm:block mr-2"></OutsideLink>
                                             <span>Procedi con il rinnovo di quest'anno</span>
                                          </v-btn>
                                       </div>
                                    </div>
                                    <div v-else-if="isRinnovoScadutoComputed && tecnico.referente_id != null && tecnico.referente.autogestisce_rinnovi == 1" class="flex-col bg-csenOrange-100 border-2 border-csenOrange-600 dark:bg-csenOrange-600  border-dashed py-4 px-6 rounded-md">
                                       <div class="flex text-csenOrange-600 dark:!text-white">
                                          <WarningIcon class="my-auto w-5 h-5"></WarningIcon>
                                          <span class="font-semibold my-auto ml-2">Ricordati di rinnovare il tuo patentino entro la data di scadenza!</span>
                                       </div>
                                       <div class="text-csenOrange-800 dark:text-csenOrange-100 text-sm mt-2 mb-3">
                                          Contatta il tuo referente
                                       </div>
                                    </div>
                                    <div style="display:none" v-else class="flex-col bg-csenGreen-50 border-2 border-csenGreen-500 dark:bg-csenGreen-500 border-dashed py-4 px-6 rounded-md">
                                       <div class="flex text-csenGreen-600 dark:!text-white">
                                          <div class="font-semibold my-auto md:ml-2">
                                             <div class="inline-flex">
                                                <VerifiedIcon class="!hidden md:!inline-flex !my-auto !w-5 !h-5 mr-2"></VerifiedIcon> 
                                                <div class="inline-flex my-auto">Il patentino è stato rinnovato per quest'anno.</div>
                                             </div>
                                             <div class="font-normal text-sm mt-0.5 text-csenGreen-800 dark:!text-white" v-if="!isRinnovatoAnnoSuccessivoComputed">
                                                Se vuoi rinnovarlo anche per l'anno successivo, clicca su "Acquista rinnovo" (<strong>25€</strong>) e seleziona l'anno. Nella schermata successiva potrai pagare con una carta.
                                             </div>
                                          </div>
                                       </div>


                                    
                                    </div>

                                 </div>

                              <!-- Tabella Rinnovi -->

                              <v-data-table
                                 id="rinnovi-table"
                                 :headers="headersRinnoviComputed"
                                 :items="tecnico.rinnovi"
                                 class=""
                                 disable-sort
                                 :footer-props="{itemsPerPageText: 'Rinnovi per pagina'}"
                              >
                                 <template v-slot:header.stampa_etichetta="{ column }">
                                    <span>Bollino Rinnovo</span>
                                 </template>

                                 <template v-slot:item.anno_rinnovo="{ item }">
                                    <div class="text-left">
                                       {{ item.anno_rinnovo }}
                                    </div>
                                 </template>
                                 <template v-slot:item.modalita_pagamento="{ item }">
                                    <div class="text-left">
                                       {{ primaLetteraMaiuscola(item.modalita_pagamento) }}
                                    </div>
                                 </template>
                                 <template v-slot:item.created_at="{ item }">
                                    <div class="text-left">
                                       {{ item.modalita_pagamento != 'diploma' && item.modalita_pagamento != 'importazione' && item.created_at ? formattaData(item.created_at.split("T")[0]) : '' }}
                                    </div>
                                 </template>

                                 <template v-slot:item.stampa_etichetta="{ item }">
                                    <!-- <span id="etichetta-rinnovo-header"></span> FORSE ??? -->
                                    <v-btn :disabled="isDownloadingPDFBollino" @click="stampaEtichetta(item)" class="etichetta-rinnovo !px-4 !text-csenBlue-700 !bg-csenBlue-50 dark:!bg-csenBlue-600 dark:!text-white !tracking-normal">
                                       <PrintIcon class="dark:!text-csenBlue-200"></PrintIcon>
                                       <span class="sm:block !ml-1">Stampa Bollino</span>
                                       <v-progress-circular v-if="isDownloadingPDFBollino" :size="20" :width="3" class="ml-2" indeterminate></v-progress-circular>
                                    </v-btn>
                                 </template>
                                 
                                 <template v-slot:item.note="{ item }">
                                    <div class="text-left">
                                       {{ item.note }}
                                    </div>
                                 </template>
                                 <!-- Azioni -->
                                 <!-- VISIBILE SOLO DA ADMIN v-if="loggedAs.ruolo=='admin'" -->
                                 <template v-if="loggedAs.ruolo == 'admin'" v-slot:item.azioni="{ item }">
                                    <div class="flex justify-left gap-x-1">
                                       <button type="button" @click="openRinnovoDialog(item)" 
                                          class="bg-csenOrange-100 !text-csenOrange-500 dark:!text-white dark:bg-csenOrange-500 inline-flex justify-center content-center px-auto rounded-md hover:bg-csenOrange-500 hover:!text-white transition w-9 h-9" 
                                          title="Modifica Rinnovo"
                                          >
                                          <EditIcon class="my-auto"></EditIcon>
                                       </button>
                                       <button type="button" @click="eliminaRinnovo(item.id)"
                                          class="bg-red-100 !text-csenRed-500 dark:!text-white dark:bg-csenRed-500 inline-flex justify-center content-center px-auto rounded-md hover:bg-csenRed-500 hover:!text-white transition w-9 h-9" 
                                          title="Elimina Rinnovo"
                                          >
                                          <DeleteIcon class="my-auto"></DeleteIcon>
                                       </button>
                                    </div>
                                 </template>
                                 <v-pagination
                                    v-model="pageRinnovi"
                                    :length="pageCountRinnovi"
                                    class="mt-4"
                                    ></v-pagination>
                              </v-data-table>
                              <v-divider></v-divider>
                           </v-card>
                        </v-tab-item>
                        <!-- FINE TAB RINNOVI -->

                     <!-- TAB ALTRI DATI DEL TECNICO -->
                     <!-- VISIBILE SOLO DA ADMIN v-if="loggedAs.ruolo=='admin'" -->
                     <v-tab-item>
                        <v-card flat class="p-9 dark:!bg-csenBlue-900 w-full !rounded-none !ring-0 !border-0">
                           <!-- Testo iniziale -->
                           <v-row dense>
                              <div class="">
                                 <h2 class="text-xl font-bold text-csenBlue-950 dark:text-csenBlue-200">Altri dati del tecnico</h2>
                                 <p class="py-1">🔔 Questa sezione è visibile e modificabile <strong>soltanto dagli amministratori</strong>.</p>
                              </div>
                           </v-row>
                           <!-- Riga 1 -->
                           <v-row dense class="mb-n3">
                              <!-- Tecnico del referente -->
                              <v-col cols="12" md="12">
                                 <p class="text-sm font-semibold mb-3 !z-50"> Tecnico del referente</p>
                                 <v-autocomplete
                                    :items="referenti"
                                    autocomplete="none"
                                    item-text="nome"
                                    item-value="id"
                                    label="Seleziona Referente"
                                    v-model="tecnico.referente_id"
                                    outlined
                                    class="!z-50"
                                    clearable
                                    @input="setTecnicoCampoModificato('referente_id')"
                                 >
                                    <template v-slot:append>
                                       <v-tooltip v-if="tecnico.id != null && tecnicoCampiModificati['referente_id']" bottom>
                                                   <template v-slot:activator="{ on, attrs }">
                                                      <span v-bind="attrs" v-on="on">
                                                         <EditingIcon class="my-auto !h-5 !w-5 !text-yellow-500" />
                                                      </span>
                                                   </template>
                                                   <span>Modifica non ancora salvata</span>
                                          </v-tooltip>     
                                         <!-- <v-icon v-if="tecnico.id != null && tecnicoCampiModificati['referente_id']" color="orange">mdi-alert</v-icon> -->
                                    </template>

                                    <template v-slot:item="{ item }">
                                       <div class="d-flex align-center">
                                       <span>{{ item.nome }}</span>
                                       <v-chip v-if="item.autogestisce_rinnovi" class="ml-2" small color="primary">
                                          Autonomo
                                       </v-chip>
                                       </div>
                                    </template>

                                    <template v-slot:selection="{ item }">
                                       <div class="d-flex align-center">
                                       <span>{{ item.nome }}</span>
                                       <v-chip v-if="item.autogestisce_rinnovi" class="ml-2" small color="primary">
                                          Autonomo
                                       </v-chip>
                                       </div>
                                    </template>

                                 </v-autocomplete>
                              </v-col>
                           </v-row>
                           <v-divider></v-divider>
                           <!-- Circolari -->
                           <v-row dense class="mb-n3 py-2">
                            
                                 <div class="!w-1/2">
                                    <v-switch
                                       v-model="tecnico.circolari_abilitate"
                                       color="primary"
                                       label="Ricezione delle circolari massive"
                                       class="gap-x-3 font-semibold !text-gray-800"
                                       @change="setTecnicoCampoModificato('circolari_abilitate')"
                                       :disabled="tecnico.is_visibile != 1 && tecnico.is_visibile != '1'"
                                    >
                                    </v-switch>
                                    <template v-if="tecnico.id != null && (tecnicoCampiModificati['circolari_abilitate'])">
                                       <div class="!text-yellow-500 !ml-2 !mb-3 inline-flex">
                                          <EditingIcon class="mr-2 my-auto !h-5 !w-5 font-semibold !text-yellow-500" />
                                          Modifica non ancora salvata
                                       </div>
                                    </template> 
                                 </div>

                                 <div class="!w-1/2">
                                       <v-switch
                                          v-model="tecnico.is_tesserino_altro_comitato"
                                          color="primary"
                                          label="Tesserino altro comitato"
                                          class="gap-x-3 font-semibold !text-gray-800"
                                          @change="setTecnicoCampoModificato('is_tesserino_altro_comitato')"
                                       >
                                       </v-switch>
                                       <template v-if="tecnico.id != null && (tecnicoCampiModificati['is_tesserino_altro_comitato'])">
                                          <div class="!text-yellow-500 !ml-2 !mb-3 inline-flex">
                                             <EditingIcon class="mr-2 my-auto !h-5 !w-5 font-semibold !text-yellow-500" />
                                             Modifica non ancora salvata
                                          </div>
                                       </template>
                                 </div>

                           </v-row>

                           <v-row dense class="mb-n3 py-2">
                            
                              <div class="!w-1/2">
                                 <v-switch
                                    v-model="tecnico.is_visibile"
                                    color="primary"
                                    label="Visibile nell'albo pubblico"
                                    class="gap-x-3 font-semibold !text-gray-800"
                                    @change="rendiTecnicoInvisibile()"
                                 >
                                 </v-switch>
                                 <template v-if="tecnico.id != null && (tecnicoCampiModificati['is_visibile'])">
                                    <div class="!text-yellow-500 !ml-2 !mb-3 inline-flex">
                                       <EditingIcon class="mr-2 my-auto !h-5 !w-5 font-semibold !text-yellow-500" />
                                       Modifica non ancora salvata
                                    </div>
                                 </template> 
                              </div>

                           </v-row>


                           <v-divider></v-divider>
                           <v-row dense class="mb-n3 flex-col">
                              <p class="text-sm font-semibold mt-4 mb-3 flex"> Note aggiuntive
                                 <template >
                                    <v-tooltip v-if="tecnico.id != null && tecnicoCampiModificati['note']" bottom>
                                                   <template v-slot:activator="{ on, attrs }">
                                                      <span v-bind="attrs" v-on="on">
                                                         <EditingIcon class="ml-2 my-auto !h-5 !w-5 !text-yellow-500" />
                                                      </span>
                                                   </template>
                                                   <span>Modifica non ancora salvata</span>
                                    </v-tooltip>      
                                 </template>
                              </p>
                              <v-textarea
                                 v-model="tecnico.note"
                                 label="Inserisci un messaggio" 
                                 outlined
                                 @input="setTecnicoCampoModificato('note')"
                              >
                              </v-textarea>
                           </v-row>
                           <v-divider></v-divider>
                        </v-card>
                     </v-tab-item>
               
                     <!-- FINE TAB ALTRI DATI DEL TECNICO -->
                  </v-tabs-items>
               </v-col>
            </v-row>
         </v-form>

         <!-- DIALOG DIPLOMI -->
         <template>
            <!-- Nota: utilizzo la funzione @click:outside per chiudere il dialog in maniera controllata ripulendo i dati all'interno -->
               <v-dialog v-model="diplomaDialog" width="600px" persistent>
               <!-- @click:outside="closeDiplomaDialog()" -->
               <v-card plain class="dark:!bg-csenBlue-800">
                  <v-card-title class="font-bold text-2xl py-6 pl-8">
                     <span class="flex-grow">
                        <h2>
                           Aggiungi / Modifica Diploma
                        </h2>
                     </span>
                     <v-btn class="!text-gray-900 dark:!text-csenBlue-200" icon @click="closeDiplomaDialog()">
                        <CloseIcon />
                     </v-btn>
                  </v-card-title>
                  <v-divider></v-divider>
                  <v-card-text class="!m-0 !p-0">
                        <v-form v-model="validDiplomaForm" ref="formDiplomaTecnico">
                           <div class="my-5 mx-8 !z-50">
                              <v-autocomplete
                                 v-model="diplomaInModifica.categoria_corso_id"
                                 autocomplete="none"
                                 :items="categorieCorsi"
                                 label="Categoria del corso"
                                 item-text="nome"
                                 item-value="id"
                                 class="!z-50"
                                 outlined
                                 :rules="[rules.required]"
                                 @change="diplomaModificato = true"
                              ></v-autocomplete>

                              <!-- IMPOSTA NOME DIPLOMA -->
                              <v-autocomplete
                                 v-model="diplomaInModifica.corso_id"
                                 autocomplete="none"
                                 :items="corsiByCategoriaId"
                                 label="Corso"
                                 item-text="nome"
                                 item-value="id"
                                 outlined
                                 class="!z-50"
                                 :rules="[rules.required]"
                                 @change="diplomaModificato = true"
                              ></v-autocomplete>
                              <v-autocomplete
                                 v-model="diplomaInModifica.edizione_id"
                                 autocomplete="none"
                                 :items="edizioniByCorsoId"
                                 label="Edizione"
                                 item-text="nome"
                                 item-value="id"
                                 outlined
                                 class="!z-50"
                                 :rules="[ruleEdizioneCorso]"
                                 @change="diplomaModificato = true"
                              ></v-autocomplete>

                              <!-- IMPOSTA DATA DI CONSEGUIMENTO -->
                              <v-text-field
                                 v-model="diplomaInModifica.data_conseguimento"
                                 label="Data di conseguimento diploma"
                                 outlined
                                 type="date"
                                 :rules="[rules.required]"
                                 @input="diplomaModificato = true"
                              >
                              </v-text-field>
                           </div>
                        </v-form>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions class="p-4 justify-end bg-white dark:!bg-csenBlue-800">
                     <v-btn class="!bg-white!tracking-wider !py-5 !px-5" text @click="closeDiplomaDialog()">Annulla</v-btn>
                     <v-btn class="!bg-csenBlue-900 !text-white !tracking-wider !py-5 !px-5" text @click="validaDiploma()">Salva diploma</v-btn>
                     </v-card-actions>
               </v-card>
            </v-dialog>
         </template>

         <!-- DIALOG RINNOVI -->
         <template>
            <v-dialog v-model="rinnoviDialog" width="1000px" persistent>
               <!-- @click:outside="closeRinnovoDialog()" -->
               <v-card plain class="dark:!bg-csenBlue-800">
                  <v-card-title class="font-bold text-2xl py-6 pl-8">
                     <span class="flex-grow">
                        <h2>
                           Aggiungi / Modifica rinnovo
                        </h2>
                     </span>
                     <v-btn class="!text-gray-900 dark:!text-csenBlue-200" icon @click="closeRinnovoDialog()">
                        <CloseIcon />
                     </v-btn>
                  </v-card-title>
                  <v-divider></v-divider>
                  <v-card-text class="!m-0 !p-0">
                        <v-form v-model="validRinnovoForm" ref="formRinnovoTecnico">
                           <div class="my-5 mx-8">
                              <div class="grid grid-cols-2 gap-x-4">
                                 <div class="col-span-1 !z-50">
                                    <!-- IMPOSTA ANNO -->			
                                    <v-select
                                       v-model="rinnovoInModifica.anno_rinnovo"
                                       :items="anniRinnoviOptions"
                                       label="Anno"
                                       item-text="anno"
                                       item-value="2024"
                                       outlined
                                       :rules="[rules.required]"
                                       class="!z-50"
                                       @change="rinnovoModificato = true"
                                    ></v-select>
                                 </div>
                                 <div class="col-span-1 !z-50">
                                    <!-- IMPOSTA MOD PAGAMENTO -->					
                                    <v-select
                                       v-model="rinnovoInModifica.modalita_pagamento"
                                       :items="modalitaPagamentoOptions"
                                       label="Modalità di pagamento"
                                       item-text="modalita_pagamento"
                                       item-value="mod_pagamento"
                                       outlined
                                       :rules="[rules.required]"
                                       class="!z-50 !capitalize"
                                       @change="rinnovoModificato = true"
                                    >
                                       <template v-slot:item="{ item }">
                                          {{ primaLetteraMaiuscola(item) }}
                                       </template>
                                    </v-select>
                                 </div>
                                 <!-- IMPOSTA NOTE -->
                                 <div class="col-span-2">
                                    <v-textarea
                                       v-model="rinnovoInModifica.note"
                                       label="Note"
                                       outlined
                                       @input="rinnovoModificato = true"
                                    ></v-textarea>
                                 </div>
                              </div>
                           </div>
                     </v-form>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions class="p-4 justify-end bg-white dark:!bg-csenBlue-800">
                     <v-btn class="!bg-white!tracking-wider !py-5 !px-5" text @click="closeRinnovoDialog()">Annulla</v-btn>
                     <v-btn class="!bg-csenBlue-900 !text-white !tracking-wider !py-5 !px-5" text @click="validaRinnovo()">Salva rinnovo</v-btn>
                  </v-card-actions>
               </v-card>
            </v-dialog>
         </template>

         <!-- DIALOG RINNOVI ALTRI ANNI (Visibile solo dal tecnico) -->
         <template>
            <v-dialog v-model="rinnovoAltriAnniDialog" width="800px" persistent>
               <!-- @click:outside="closeRinnovoAltriAnniDialog()" -->
               <v-card plain class="dark:!bg-csenBlue-800 !ring-0 !border-0">
                  <v-card-title class="font-bold text-2xl py-6 pl-8">
                     <span class="flex-grow">
                        <h2>
                           Rinnova un anno specifico
                        </h2>
                     </span>
                     <v-btn class="!text-gray-900" icon @click="closeRinnovoAltriAnniDialog()">
                        <CloseIcon />
                     </v-btn>
                  </v-card-title>
                  <v-divider></v-divider>
                  <v-card-text class="!m-0 !p-0">
                     <v-form v-model="validRinnovoAltriAnniForm" ref="formRinnovoAltriAnni">
                        <div class="my-5 mx-8">
                           <div class="grid grid-cols-2 gap-x-4">
                              <div class="col-span-2 !z-50">
                                 <v-select
                                    v-model="annoRinnovoAltriAnni"
                                    :items="anniDisponibiliRinnovoAltriAnni"
                                    label="Anno da rinnovare"
                                    outlined
                                    :rules="[rules.required]"
                                    class="!z-50"
                                    hide-details
                                 ></v-select>
                                 <div class="mt-2">
                                    <span v-html="annoRinnovoAltriAnniTextComputed"></span>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </v-form>
                  </v-card-text>
                  <v-card-actions class="p-4 justify-end bg-white dark:!bg-csenBlue-800">
                     <v-btn class="!bg-white!tracking-wider !py-5 !px-5" text @click="closeRinnovoAltriAnniDialog()">Annulla e torna indietro</v-btn>
                     <v-btn class="!bg-csenBlue-900 !text-white !tracking-wider !py-5 !px-5" text @click="pagamentoRinnovoAltroAnno()">Acquista</v-btn>
                  </v-card-actions>
               </v-card>
            </v-dialog>
         </template>

      </v-container>

      <v-tour name="myTourPannelloTecnici" :steps="tourStepsComputed" :options="tourOptions" :callbacks="tourCallbacks"></v-tour>

      <!-- Overlay per bloccare i click durante il tour -->
      <div v-if="tourAvviato" class="tour-overlay"></div>
  </div>
</template>

<script>
  /* icone custom */
   import ContattiIcon from '../components//icons/ContattiIcon.vue';
   import VerifiedIcon from '../components//icons/VerifiedIcon.vue';
   import AddressIcon from '../components/icons/AddressIcon.vue';
   import UserIcon from '../components/icons/UserIcon.vue';
   import GraduationIcon from '../components/icons/GraduationIcon.vue';
   import PhoneIcon from '../components/icons/PhoneIcon.vue';
   import InfoIcon from '../components/icons/InfoIcon.vue';
   import UserSearchIcon from '../components/icons/UserSearchIcon.vue';
   import IdCardIcon from '../components/icons/IdCardIcon.vue';
   import OutsideLink from '../components/icons/OutsideLink.vue';
   import WarningIcon from './icons/WarningIcon.vue';
   import LockIcon from './icons/LockIcon.vue';
   import EditingIcon from './icons/EditingIcon.vue';
  

   import mixin from '../mixin';
   import store from '../store';
import { capitalize } from 'lodash';

   export default {
      name: "PannelloTecniciComponente",
      components: {
         GraduationIcon, WarningIcon, AddressIcon, LockIcon, VerifiedIcon, IdCardIcon, OutsideLink
      },
      mixins: [mixin],
      props: ['tecnicoId', 'vaiATab'],
      data() {
         return {
            tourCallbacks: {
               onFinish: this.completoTour,
               onSkip: this.interrottoTour,
               onStop: this.interrottoTour,
            },
            tourAvviato: false,

            // NOTA: quando aggiungo parametri qui, inserirli anche nella funzione reset()

            // Gestione dei comuni
            nazioni: [],
            isLoadingNazioni: false,

            province: [], // Valido per tutti
            isLoadingProvince: false,

            validForm: null,
            validDiplomaForm: null,
            validRinnovoForm: null,
            
            // Nascita
            comuniByProvinciaNascita: [],

            // Residenza
            comuniByProvinciaResidenza: [],
            capsByComuneResidenza: [],

            // Domicilio
            comuniByProvinciaDomicilio: [],
            capsByComuneDomicilio: [],

            // Spedizione
            comuniByProvinciaSpedizione: [],
            capsByComuneSpedizione: [],

            isLoadingCodiceFiscale: false,

            menu: false,
            rinnoviDialog:false,
            diplomaDialog:false,
            tab: 0,
            tabs: [
               { title: "Dati anagrafici", icon: IdCardIcon, short: 'anagrafica', id: 'anagrafica-tab' },
               { title: "Contatti", icon: PhoneIcon, short: 'contatti', id: 'contatti-tab' },
               { title: "Indirizzi", icon: AddressIcon, short: 'indirizzi', id: 'indirizzi-tab' },
               { title: "Diplomi", icon: GraduationIcon, short: 'diplomi', id: 'diplomi-tab' },
               { title: "Rinnovi", icon: VerifiedIcon, short: 'rinnovi', id: 'rinnovi-tab' },
               { title: "Altri dati del tecnico", icon: UserSearchIcon, only_admin: true, short: 'altri_dati', id: 'altri-dati-tab' },
            ],

            mostraAltroNumero: false,

            referenti: [],

            codiceFiscaleTimer: null,

            tecnico: {
               id: null,
               nome: null,
               cognome: null,
               sesso: null,
               
               sigla_provincia_nascita: null,
               comune_nascita: null,
               data_nascita: null,
               codice_fiscale: null,

               is_codice_fiscale_manuale: false,

               referente_id: null,

               // Residenza
               is_manuale_residenza: false,
               indirizzo_residenza: null,
               civico_residenza: null,
               is_snc_residenza: false,
               nazione_residenza: 'ITALIA',
               sigla_provincia_residenza: null,
               comune_residenza: null,
               cap_residenza: null,

               // Domicilio
               is_manuale_domicilio: false,
               indirizzo_domicilio: null,
               civico_domicilio: null,
               is_snc_domicilio: false,
               nazione_domicilio: 'ITALIA',
               sigla_provincia_domicilio: null,
               comune_domicilio: null,
               cap_domicilio: null,

               // Spedizione
               is_manuale_spedizione: false,
               indirizzo_spedizione: null,
               civico_spedizione: null,
               is_snc_spedizione: false,
               nazione_spedizione: 'ITALIA',
               sigla_provincia_spedizione: null,
               comune_spedizione: null,
               cap_spedizione: null,
               presso_spedizione: null,

               // Contatti
               cellulare: null,
               telefono_fisso: null,
               altro_numero: null,
               email: null,
               // showAltroNumero: false,
               
               circolari_abilitate: true,
               is_tesserino_altro_comitato: false,
               is_visibile: true,

               note: null,

               diplomi: [],
               rinnovi: [],
            },
            tecnicoCampiModificati: {},
            sezioniModificate: {},

            page: 1,
            pageCount: 2,
                  
            pageRinnovi: 1,
            pageCountRinnovi: 1,

            searchTimer: null, // Timer prima di effettuare chiamata API per gli indirizzi

            // Ricerca degli indirizzi di residenza
            residenzaSelected: null, // Valore selezionato
            residenzaOptions: [], // Possibili scelte in base alla stringa di ricerca
            isLoadingResidenzaSearch: false,
            residenzaSearchText: null, // Stringa di ricerca

            domicilioSelected: null,
            domicilioOptions: [],
            isLoadingDomicilioSearch: false,
            domicilioSearchText: null,

            spedizioneSelected: null,
            spedizioneOptions: [],
            isLoadingSpedizioneSearch: false,
            spedizioneSearchText: null,

            // Per la modifica/aggiunta di un diploma
            categorieCorsi: [],
            corsiByCategoriaId: [],
            edizioniByCorsoId: [],
            diplomaInModifica: {
               isNew: true,
               categoria_corso_id: null,
               corso_id: null,
               nome_corso: null,
               edizione_id: null,
               nome_edizione: null,
               data_conseguimento: null,
            },
            
            // I due seguenti forniscono la chiave primaria dell'istanza (necessario in fase di modifica per capire quale record modificare nel BE)
            diplomaInModificaCorsoIdIniziale: null,
            diplomaInModificaEdizioneIdIniziale: null,

            anniRinnoviOptions: [], // Impostato al created
            modalitaPagamentoOptions: ['bollettino','bonifico','paypal','stripe','carta','contanti'], // Manca 'diploma' perché non selezionabile dall'utente
            rinnovoInModifica: {
               isNew: true,
               id: null,
               anno_rinnovo: null,
               modalita_pagamento: null,
               note: null
            },

            // Funzioni che attendono che le province vengano prese
            funzioniInAttesaProvince: [],

            // Per far mostrare il CF come campo modificato solo se la modifica non è dovuta al primo caricamento
            tecnicoAppenaOttenuto: false,

            rinnovoAltriAnniDialog: false,
            annoRinnovoAltriAnni: null,
            validRinnovoAltriAnniForm: null,

            // tecnicoModificato: false,
            diplomaModificato: false,
            rinnovoModificato: false,

            isDownloadingPDFBollino: false,
         };
      },
      created(){
         this.ricreaTecnicoCampiModificati();

         // Carico le nazioni (Italia di default):
         this.getNazioni();

         // Prendo le province e dentro getProvincia verrà impostata anche la mappa di conversione NomeProvincia->SiglaProvincia:
         this.getProvince();

         // Il seguente viene utilizzato la prima volta che il componente è montato (il watch invece le volte successive!)
         if(this.tecnicoId)
            this.getTecnico();

         let annoAttuale = new Date().getFullYear();
         // E' possibile che vengano inseriti anche altri anni se non presenti in elenco
         this.anniRinnoviOptions = [];
         for (let anno = annoAttuale + 1; anno >= 1995; anno--){ // Aggiungiamo gli anni dal più recente fino al 1995
            this.anniRinnoviOptions.push(anno);
         }
         //this.anniRinnoviOptions = [annoAttuale+1, annoAttuale, annoAttuale-1, annoAttuale-2, annoAttuale-3];

         // In alcuni contesti (es: dopo pagamento del rinnovo) apro direttamente un tab passato come GET
         const startTab = this.$route.query.start_tab;
         if (startTab !== undefined && !isNaN(startTab))
            this.tab = parseInt(startTab);

         // Nel created non funziona il seguente if perché viene chiamato ancor prima che loggedAs venga inizializzato
         // => soluzione: aggiunto ad un watcher del tab
         // if(this.loggedAs && this.loggedAs.ruolo == 'admin'){
         //    this.getReferenti();
         // }
      },
      watch: {
         tecnicoId: {
            handler(newVal, oldVal) {
               //if(oldVal != null) // Resetto solo se precedentemente non avevo già l'id a null

               // Li riprendo ad ogni modifica, dal momento che prima loggedAs (essendo il dialog 'eager') potrebbe non esserci
               //if(this.loggedAs && this.loggedAs.ruolo == 'admin'){  // => Spostato nel watcher del tab
                  // this.getReferenti(); // => Spostato nel watcher del tab
                  //this.getCategorieCorsi();  // => Spostato nel watcher del tab
               //}

               this.reset();

               if(this.vaiATab)
                  this.tab = this.vaiATab;
               
               const startTab = this.$route.query.start_tab;
               if (startTab !== undefined && !isNaN(startTab))
                  this.tab = parseInt(startTab);

               if(this.tecnicoId){
                  this.getTecnico();
               }
            },
         },

         tab: {
            handler(newVal, oldVal) {
               if(this.loggedAs && this.loggedAs.ruolo == 'admin'){
                  if(this.tab == 3){
                     if(this.categorieCorsi.length == 0)
                        this.getCategorieCorsi();
                  }
                  else if(this.tab == 5){
                     if(this.referenti.length == 0)
                        this.getReferenti();
                  }
               }
            }
         },

         // Per il calcolo automatico del Codice Fiscale:
         'tecnico.nome':{
            handler(newVal, oldVal) {
               if(!this.tecnicoAppenaOttenuto)
                  this.calcolaCodiceFiscale();
            }
         },
         'tecnico.cognome':{
            handler(newVal, oldVal) {
               if(!this.tecnicoAppenaOttenuto)
                  this.calcolaCodiceFiscale();
            }
         },
         'tecnico.sesso':{
            handler(newVal, oldVal) {
               if(!this.tecnicoAppenaOttenuto)
                  this.calcolaCodiceFiscale();
            }
         },
         'tecnico.sigla_provincia_nascita':{
            handler(newVal, oldVal) {
               // this.calcolaCodiceFiscale(); // Se cambia la provincia aggiorno i comuni ma non ricalcolo il CF
               
               // NOTA 1: entra qui anche al primo caricamento, in tal caso oldVal sarà = null, quindi non devo azzerrare il comune_nascita
               // NOTA 2: se invece è un nuovo tecnico (tecnicoId = null), ovviamente il comune_nascita sarà inizialmente a null
               if(oldVal != null && this.tecnicoId != null){
                  this.tecnico.comune_nascita = null;
               }

               this.getComuniBySiglaProvincia(this.tecnico.sigla_provincia_nascita, (comuni)=>{
                  this.comuniByProvinciaNascita = comuni;
               })
            }
         },
         'tecnico.comune_nascita':{
            handler(newVal, oldVal) {
               if(!this.tecnicoAppenaOttenuto)
                  this.calcolaCodiceFiscale();
            }
         },
         'tecnico.data_nascita':{
            handler(newVal, oldVal) {
               if(!this.tecnicoAppenaOttenuto)
                  this.calcolaCodiceFiscale();
            }
         },
         'tecnico.is_codice_fiscale_manuale':{
            handler(newVal, oldVal) {
               if((!this.tecnico.is_codice_fiscale_manuale || this.tecnico.is_codice_fiscale_manuale == 0) && !this.tecnicoAppenaOttenuto){
                  this.calcolaCodiceFiscale();
               }
            }
         },

         // Per la gestione e ricerca dell'indirizzo di residenza
         residenzaSearchText:{
            handler(newVal, oldVal) {
               this.isLoadingResidenzaSearch = false;
               clearTimeout(this.searchTimer);

               this.residenzaOptions = [];
               this.residenzaSelected = null; // Se cerco quella precedente deve andare di nuovo a null

               if(!this.residenzaSearchText || this.residenzaSearchText.length < 3/* || this.isLoadingResidenzaSearch*/){
                  return;
               }

               this.isLoadingResidenzaSearch = true;

               this.cercaIndirizzo(this.residenzaSearchText, (indirizzi) => {
                  this.residenzaOptions = indirizzi;
                  this.isLoadingResidenzaSearch = false;
               });
            },
         },
         residenzaSelected: { // Cliccato su un nuovo indirizzo cercato con API
            handler(newVal, oldVal) {
               this.residenzaSearchText = null; // Appena selezionato elimino la ricerca

               if(this.residenzaSelected == null) return;
               
               this.tecnico.nazione_residenza = 'ITALIA' // Imposto l'Italia come nazione di default
               this.tecnico.indirizzo_residenza = this.residenzaSelected.indirizzo
               this.tecnico.civico_residenza = this.residenzaSelected.civico
               this.tecnico.comune_residenza = this.residenzaSelected.comune

               this.setTecnicoCampoModificato('tutto_residenza')

               // Se non trova la sigla della provincia allora mette l'intero nome della provincia
               // if(this.residenzaSelected.provincia in this.nomeProvinciaToSigla){
               //    this.tecnico.sigla_provincia_residenza = this.nomeProvinciaToSigla[this.residenzaSelected.provincia];
               // } else {
               //    this.tecnico.sigla_provincia_residenza = this.residenzaSelected.provincia
               // }
               // Non è più necessario avere la tabella di conversione da Provincia a Sigla Provincia (adesso è implementata nell'API):
               this.tecnico.sigla_provincia_residenza = this.residenzaSelected.siglaProvincia

               this.tecnico.cap_residenza = this.residenzaSelected.cap

               if(!this.tecnico.civico_residenza || this.tecnico.civico_residenza == ''){
                  this.tecnico.is_snc_residenza = 1;
               } else {
                  this.tecnico.is_snc_residenza = 0;
               }

               this.comuniByProvinciaResidenza = [{nome: this.tecnico.comune_residenza}]; // Inserisco solo il comune selezionato
               this.capsByComuneResidenza = [{codice: this.tecnico.cap_residenza}];  // Inserisco solo il cap selezionato
            },
            deep: true
         },
         'tecnico.is_manuale_residenza': {
            handler(newVal, oldVal){
               if(this.tecnico.is_manuale_residenza && !this.tecnicoAppenaOttenuto){ // Se impostato a true, resetto gli array e vedo se qualcosa è già stata impostata
                  // Ottengo di nuovo l'elenco delle province:
                  this.getProvince();

                  this.comuniByProvinciaResidenza = [];
                  this.capsByComuneResidenza = [];

                  // Imposto a null al momento la parte scomoda (le 3 select che potrebbero non corrispondere)
                  this.tecnico.nazione_residenza = 'ITALIA'; // Imposto l'Italia come nazione di default
                  this.tecnico.sigla_provincia_residenza = null;
                  this.tecnico.comune_residenza = null;
                  this.tecnico.cap_residenza = null;
               }
            },
         },
         'tecnico.nazione_residenza': {
            handler(newVal, oldVal){
               if(this.tecnico.is_manuale_spedizione && !this.tecnicoAppenaOttenuto && oldVal != null){
                  // Quando cambio nazione, resetto i campi provincia, comune e CAP
                  this.tecnico.sigla_provincia_residenza = null;
                  this.tecnico.comune_residenza = null;
                  this.tecnico.cap_residenza = null;
                  this.comuniByProvinciaResidenza = [];
                  this.capsByComuneResidenza = [];

                  // Se la nuova nazione è Italia, ricarico le province
                  if(newVal === 'ITALIA'){
                     this.getProvince();
                  }
               }
            },
         },
         'tecnico.sigla_provincia_residenza': { // Quando cambia la sigla della provincia, cerca i relativi comuni
            handler(newVal, oldVal){
               if(this.tecnico.is_manuale_residenza){
                  this.capsByComuneResidenza = []

                  if(!this.tecnicoAppenaOttenuto){
                     this.tecnico.comune_residenza = null;
                     this.tecnico.cap_residenza = null;
                  }

                  // Solo per Italia cerco i comuni tramite API
                  if(this.tecnico.nazione_residenza === 'ITALIA'){
                     this.getComuniBySiglaProvincia(this.tecnico.sigla_provincia_residenza, (comuni)=>{
                        this.comuniByProvinciaResidenza = comuni;

                        // Se vi era un comune selezionato, prendo anche i caps:
                        if(this.tecnico.comune_residenza){
                           let idComune = this.getIdComuneByComune(this.tecnico.comune_residenza, this.comuniByProvinciaResidenza);
                           this.getCapsByIdComune(idComune, (caps)=>{
                              this.capsByComuneResidenza = caps;
                           });
                        }
                     });
                  }
               } else { // Se è automatico allora riempio gli array con i soli comuni-cap-..
                  this.comuniByProvinciaResidenza = [{nome: this.tecnico.comune_residenza}]; // Inserisco solo il comune selezionato
                  this.capsByComuneResidenza = [{codice: this.tecnico.cap_residenza}];  // Inserisco solo il cap selezionato
               }
            },
         },
         'tecnico.comune_residenza': { // Quando cambia il comune di residenza, cerca i relativi caps
            handler(newVal, oldVal){
               if(this.tecnico.is_manuale_residenza && this.tecnico.nazione_residenza === 'ITALIA'){                  
                  let idComune = this.getIdComuneByComune(this.tecnico.comune_residenza, this.comuniByProvinciaResidenza);

                  if(idComune != null){
                     this.getCapsByIdComune(idComune, (caps)=>{
                        this.capsByComuneResidenza = caps;
                     });
                  }
               }
            },
         },
         'tecnico.is_snc_residenza': {
            handler(newVal, oldVal){
               if(this.tecnico.is_snc_residenza == 1){
                  this.tecnico.civico_residenza = null;
               }
            },
         },

         // Per la gestione e ricerca dell'indirizzo di domicilio (COPIA-INCOLLA dal precedente cambiando 'residenza' in 'domicilio' (maiuscola e minuscola) su Notepad++)
         domicilioSearchText:{
            handler(newVal, oldVal) {
               this.isLoadingDomicilioSearch = false;
               clearTimeout(this.searchTimer);

               this.domicilioOptions = [];
               this.domicilioSelected = null; // Se cerco quella precedente deve andare di nuovo a null

               if(!this.domicilioSearchText || this.domicilioSearchText.length < 3/* || this.isLoadingDomicilioSearch*/){
                  return;
               }

               this.isLoadingDomicilioSearch = true;

               this.cercaIndirizzo(this.domicilioSearchText, (indirizzi) => {
                  this.domicilioOptions = indirizzi;
                  this.isLoadingDomicilioSearch = false;
               });
            },
         },
         domicilioSelected: { // Cliccato su un nuovo indirizzo cercato con API
            handler(newVal, oldVal) {
               this.domicilioSearchText = null; // Appena selezionato elimino la ricerca

               if(this.domicilioSelected == null) return;

               this.tecnico.nazione_domicilio = 'ITALIA' // Imposto l'Italia come nazione di default
               this.tecnico.indirizzo_domicilio = this.domicilioSelected.indirizzo
               this.tecnico.civico_domicilio = this.domicilioSelected.civico
               this.tecnico.comune_domicilio = this.domicilioSelected.comune

               this.setTecnicoCampoModificato('tutto_domicilio')

               // Se non trova la sigla della provincia allora mette l'intero nome della provincia
               // if(this.domicilioSelected.provincia in this.nomeProvinciaToSigla){
               //    this.tecnico.sigla_provincia_domicilio = this.nomeProvinciaToSigla[this.domicilioSelected.provincia];
               // } else {
               //    this.tecnico.sigla_provincia_domicilio = this.domicilioSelected.provincia
               // }
               this.tecnico.sigla_provincia_domicilio = this.domicilioSelected.siglaProvincia

               this.tecnico.cap_domicilio = this.domicilioSelected.cap

               if(!this.tecnico.civico_domicilio || this.tecnico.civico_domicilio == ''){
                  this.tecnico.is_snc_domicilio = 1;
               } else {
                  this.tecnico.is_snc_domicilio = 0;
               }

               this.comuniByProvinciaDomicilio = [{nome: this.tecnico.comune_domicilio}]; // Inserisco solo il comune selezionato
               this.capsByComuneDomicilio = [{codice: this.tecnico.cap_domicilio}];  // Inserisco solo il cap selezionato
            },
            deep: true
         },
         'tecnico.is_manuale_domicilio': {
            handler(newVal, oldVal){
               if(this.tecnico.is_manuale_domicilio && !this.tecnicoAppenaOttenuto){ // Se impostato a true, resetto gli array e vedo se qualcosa è già stata impostata
                  // Ottengo di nuovo l'elenco delle province:
                  this.getProvince();

                  this.comuniByProvinciaDomicilio = [];
                  this.capsByComuneDomicilio = [];

                  // Imposto a null al momento la parte scomoda (le 3 select che potrebbero non corrispondere)
                  this.tecnico.nazione_domicilio = 'ITALIA'; // Imposto l'Italia come nazione di default
                  this.tecnico.sigla_provincia_domicilio = null;
                  this.tecnico.comune_domicilio = null;
                  this.tecnico.cap_domicilio = null;
               }
               // Stranamente se inserisco questo viene mostrato 'null' per comune_domicilio e cap_domicilio
               // else if (!this.tecnico.is_manuale_domicilio && !this.tecnicoAppenaOttenuto) { // Resetto tutti i campi per inserirli automaticamente
               //    this.tecnico.indirizzo_domicilio = null;
               //    this.tecnico.civico_domicilio = null;
               //    this.tecnico.is_snc_domicilio = null;
               //    this.tecnico.sigla_provincia_domicilio = null;
               //    this.tecnico.comune_domicilio = null;
               //    this.tecnico.cap_domicilio = null;
               // }
            },
         },
         'tecnico.nazione_domicilio': {
            handler(newVal, oldVal){
               if(this.tecnico.is_manuale_spedizione && !this.tecnicoAppenaOttenuto && oldVal != null){
                  // Quando cambio nazione, resetto i campi provincia, comune e CAP
                  this.tecnico.sigla_provincia_domicilio = null;
                  this.tecnico.comune_domicilio = null;
                  this.tecnico.cap_domicilio = null;
                  this.comuniByProvinciaDomicilio = [];
                  this.capsByComuneDomicilio = [];

                  // Se la nuova nazione è Italia, ricarico le province
                  if(newVal === 'ITALIA'){
                     this.getProvince();
                  }
               }
            },
         },
         'tecnico.sigla_provincia_domicilio': { // Quando cambia la sigla della provincia, cerca i relativi comuni
            handler(newVal, oldVal){
               if(this.tecnico.is_manuale_domicilio){
                  this.capsByComuneDomicilio = []

                  if(!this.tecnicoAppenaOttenuto){
                     this.tecnico.comune_domicilio = null;
                     this.tecnico.cap_domicilio = null;
                  }

                  // Solo per Italia cerco i comuni tramite API
                  if(this.tecnico.nazione_domicilio === 'ITALIA'){
                     this.getComuniBySiglaProvincia(this.tecnico.sigla_provincia_domicilio, (comuni)=>{
                        this.comuniByProvinciaDomicilio = comuni;

                        // Se vi era un comune selezionato, prendo anche i caps:
                        if(this.tecnico.comune_domicilio){
                           let idComune = this.getIdComuneByComune(this.tecnico.comune_domicilio, this.comuniByProvinciaDomicilio);
                           this.getCapsByIdComune(idComune, (caps)=>{
                              this.capsByComuneDomicilio = caps;
                           });
                        }
                     });
                  }
               } else { // Se è automatico allora riempio gli array con i soli comuni-cap-..
                  this.comuniByProvinciaDomicilio = [{nome: this.tecnico.comune_domicilio}]; // Inserisco solo il comune selezionato
                  this.capsByComuneDomicilio = [{codice: this.tecnico.cap_domicilio}];  // Inserisco solo il cap selezionato
               }
            },
         },
         'tecnico.comune_domicilio': { // Quando cambia il comune di domicilio, cerca i relativi caps
            handler(newVal, oldVal){
               if(this.tecnico.is_manuale_domicilio && this.tecnico.nazione_domicilio === 'ITALIA'){
                  let idComune = this.getIdComuneByComune(this.tecnico.comune_domicilio, this.comuniByProvinciaDomicilio);
                  if(idComune != null){
                     this.getCapsByIdComune(idComune, (caps)=>{
                        this.capsByComuneDomicilio = caps;
                     });
                  }
               }
            },
         },
         'tecnico.is_snc_domicilio': {
            handler(newVal, oldVal){
               if(this.tecnico.is_snc_domicilio == 1){
                  this.tecnico.civico_domicilio = null;
               }
            },
         },

         // Per la gestione e ricerca dell'indirizzo di spedizione (COPIA-INCOLLA dal precedente cambiando 'residenza' in 'domicilio' (maiuscola e minuscola) su Notepad++)
         spedizioneSearchText:{
            handler(newVal, oldVal) {
               this.isLoadingSpedizioneSearch = false;
               clearTimeout(this.searchTimer);

               this.spedizioneOptions = [];
               this.spedizioneSelected = null; // Se cerco quella precedente deve andare di nuovo a null

               if(!this.spedizioneSearchText || this.spedizioneSearchText.length < 3/* || this.isLoadingSpedizioneSearch*/){
                  return;
               }

               this.isLoadingSpedizioneSearch = true;

               this.cercaIndirizzo(this.spedizioneSearchText, (indirizzi) => {
                  this.spedizioneOptions = indirizzi;
                  this.isLoadingSpedizioneSearch = false;
               });
            },
         },
         spedizioneSelected: { // Cliccato su un nuovo indirizzo cercato con API
            handler(newVal, oldVal) {
               this.spedizioneSearchText = null; // Appena selezionato elimino la ricerca

               if(this.spedizioneSelected == null) return;
               
               this.tecnico.nazione_spedizione = 'ITALIA' // Imposto l'Italia come nazione di default
               this.tecnico.indirizzo_spedizione = this.spedizioneSelected.indirizzo
               this.tecnico.civico_spedizione = this.spedizioneSelected.civico
               this.tecnico.comune_spedizione = this.spedizioneSelected.comune

               this.setTecnicoCampoModificato('tutto_spedizione')

               // Se non trova la sigla della provincia allora mette l'intero nome della provincia
               // if(this.spedizioneSelected.provincia in this.nomeProvinciaToSigla){
               //    this.tecnico.sigla_provincia_spedizione = this.nomeProvinciaToSigla[this.spedizioneSelected.provincia];
               // } else {
               //    this.tecnico.sigla_provincia_spedizione = this.spedizioneSelected.provincia
               // }
               this.tecnico.sigla_provincia_spedizione = this.spedizioneSelected.siglaProvincia

               this.tecnico.cap_spedizione = this.spedizioneSelected.cap

               if(!this.tecnico.civico_spedizione || this.tecnico.civico_spedizione == ''){
                  this.tecnico.is_snc_spedizione = 1;
               } else {
                  this.tecnico.is_snc_spedizione = 0;
               }

               this.comuniByProvinciaSpedizione = [{nome: this.tecnico.comune_spedizione}]; // Inserisco solo il comune selezionato
               this.capsByComuneSpedizione = [{codice: this.tecnico.cap_spedizione}];  // Inserisco solo il cap selezionato
            },
            deep: true
         },
         'tecnico.is_manuale_spedizione': {
            handler(newVal, oldVal){
               if(this.tecnico.is_manuale_spedizione && !this.tecnicoAppenaOttenuto){ // Se impostato a true, resetto gli array e vedo se qualcosa è già stata impostata
                  // Ottengo di nuovo l'elenco delle province:
                  this.getProvince();

                  this.comuniByProvinciaSpedizione = [];
                  this.capsByComuneSpedizione = [];

                  // Imposto a null al momento la parte scomoda (le 3 select che potrebbero non corrispondere)
                  this.tecnico.nazione_spedizione = 'ITALIA'; // Imposto l'Italia come nazione di default
                  this.tecnico.sigla_provincia_spedizione = null;
                  this.tecnico.comune_spedizione = null;
                  this.tecnico.cap_spedizione = null;
               }
            },
         },
         'tecnico.nazione_spedizione': {
            handler(newVal, oldVal){
               // Fai le modifiche solo se siamo in modalità manuale 
               if(this.tecnico.is_manuale_spedizione && !this.tecnicoAppenaOttenuto && oldVal != null){
                  // Quando cambio nazione, resetto i campi provincia, comune e CAP
                  this.tecnico.sigla_provincia_spedizione = null;
                  this.tecnico.comune_spedizione = null;
                  this.tecnico.cap_spedizione = null;
                  this.comuniByProvinciaSpedizione = [];
                  this.capsByComuneSpedizione = [];

                  // Se la nuova nazione è Italia, ricarico le province
                  if(newVal === 'ITALIA'){
                     this.getProvince();
                  }
               }
            },
         },
         'tecnico.sigla_provincia_spedizione': { // Quando cambia la sigla della provincia, cerca i relativi comuni
            handler(newVal, oldVal){
               if(this.tecnico.is_manuale_spedizione){
                  this.capsByComuneSpedizione = []

                  if(!this.tecnicoAppenaOttenuto){
                     this.tecnico.comune_spedizione = null;
                     this.tecnico.cap_spedizione = null;
                  }
                  
                  // Solo per Italia cerco i comuni tramite API
                  if(this.tecnico.nazione_spedizione === 'ITALIA'){
                     this.getComuniBySiglaProvincia(this.tecnico.sigla_provincia_spedizione, (comuni)=>{
                        this.comuniByProvinciaSpedizione = comuni;

                        // Se vi era un comune selezionato, prendo anche i caps:
                        if(this.tecnico.comune_spedizione){
                           let idComune = this.getIdComuneByComune(this.tecnico.comune_spedizione, this.comuniByProvinciaSpedizione);
                           this.getCapsByIdComune(idComune, (caps)=>{
                              this.capsByComuneSpedizione = caps;
                           });
                        }
                     });
                  }
               } else { // Se è automatico allora riempio gli array con i soli comuni-cap-..
                  this.comuniByProvinciaSpedizione = [{nome: this.tecnico.comune_spedizione}]; // Inserisco solo il comune selezionato
                  this.capsByComuneSpedizione = [{codice: this.tecnico.cap_spedizione}];  // Inserisco solo il cap selezionato
               }
            },
         },
         'tecnico.comune_spedizione': { // Quando cambia il comune di spedizione, cerca i relativi caps
            handler(newVal, oldVal){
               if(this.tecnico.is_manuale_spedizione && this.tecnico.nazione_spedizione === 'ITALIA'){
                  let idComune = this.getIdComuneByComune(this.tecnico.comune_spedizione, this.comuniByProvinciaSpedizione);

                  if(idComune != null){
                     this.getCapsByIdComune(idComune, (caps)=>{
                        this.capsByComuneSpedizione = caps;
                     });
                  }
               }
            },
         },
         'tecnico.is_snc_spedizione': {
            handler(newVal, oldVal){
               if(this.tecnico.is_snc_spedizione == 1){
                  this.tecnico.civico_spedizione = null;
               }
            },
         },

         'diplomaInModifica.categoria_corso_id':{
            handler(newVal, oldVal){
               if(newVal != null){
                  this.getCorsiByCategoriaCorsoId(this.diplomaInModifica.categoria_corso_id);
               } else {
                  this.diplomaInModifica.corso_id = null;
                  this.diplomaInModifica.edizione_id = null;

                  this.corsiByCategoriaId = [];
                  this.edizioniByCorsoId = [];
               }
            }
         },
         'diplomaInModifica.corso_id':{
            handler(newVal, oldVal){
               if(newVal != null){
                  this.getEdizioniByCorsoId(this.diplomaInModifica.corso_id);
               } else {
                  this.diplomaInModifica.edizione_id = null;
                  this.edizioniByCorsoId = [];
               }
            }
         },
      },
      methods: {
         spostaATab(tab){
            this.tab = tab;
         },

         tabAnchorClick(index) {
               // Imposta la tab selezionata
               this.tab = index;

               // Mappatura degli ID delle ancore per ciascuna tab
               const anchorMap = {
               0: 'AnchorDatiAnagrafici',
               1: 'AnchorContatti',
               2: 'AnchorIndirizzi',
               3: 'AnchorDiplomi',
               4: 'AnchorRinnovi'
               };

               // Verifica se l'utente è su mobile
               if (window.innerWidth < 768) {
               const targetId = anchorMap[index];
               const targetElement = document.getElementById(targetId);
               if (targetElement) {
                  // Ritarda leggermente lo scroll per assicurarsi che il DOM sia aggiornato
                  setTimeout(() => {
                     targetElement.scrollIntoView({ behavior: 'smooth' });
                  }, 50); // Ritardo di 50ms
               }
               }
         },


         avviaTour(){
            this.tourAvviato = true;

            this.$tours['myTourPannelloTecnici'].start();
         },
         completoTour(){
            this.tourAvviato = false;
         },
         interrottoTour(){
            this.tourAvviato = false;
         },
         reset(){
            // this.province = []; // Province si caricano una volta poi saranno sempre disponibili
            this.isLoadingProvince = false;

            // Nascita
            this.comuniByProvinciaNascita = [];

            // Residenza
            this.comuniByProvinciaResidenza = [];
            this.capsByComuneResidenza = [];

            // Domicilio
            this.comuniByProvinciaDomicilio = [];
            this.capsByComuneDomicilio = [];

            // Spedizione
            this.comuniByProvinciaSpedizione = [];
            this.capsByComuneSpedizione = [];

            this.isLoadingCodiceFiscale = false;

            this.tab = 0;
            
            this.mostraAltroNumero = false;

            this.codiceFiscaleTimer = null;

            this.tecnico.id = null;
            this.tecnico.nome = null;
            this.tecnico.cognome = null;
            this.tecnico.sesso = null;
            this.tecnico.sigla_provincia_nascita = null;
            this.tecnico.comune_nascita = null;
            this.tecnico.data_nascita = null;
            this.tecnico.codice_fiscale = null;
            this.tecnico.is_codice_fiscale_manuale = false;
            this.tecnico.referente_id = null;
            // Residenza
            this.tecnico.is_manuale_residenza = false;
            this.tecnico.indirizzo_residenza = null;
            this.tecnico.civico_residenza = null;
            this.tecnico.is_snc_residenza = false;
            this.tecnico.nazione_residenza = 'ITALIA';
            this.tecnico.sigla_provincia_residenza = null;
            this.tecnico.comune_residenza = null;
            this.tecnico.cap_residenza = null;
            // Domicilio
            this.tecnico.is_manuale_domicilio = false;
            this.tecnico.indirizzo_domicilio = null;
            this.tecnico.civico_domicilio = null;
            this.tecnico.is_snc_domicilio = false;
            this.tecnico.nazione_domicilio = 'ITALIA';
            this.tecnico.sigla_provincia_domicilio = null;
            this.tecnico.comune_domicilio = null;
            this.tecnico.cap_domicilio = null;
            // Spedizione
            this.tecnico.is_manuale_spedizione = false;
            this.tecnico.indirizzo_spedizione = null;
            this.tecnico.civico_spedizione = null;
            this.tecnico.is_snc_spedizione = false;
            this.tecnico.nazione_spedizione = 'ITALIA';
            this.tecnico.sigla_provincia_spedizione = null;
            this.tecnico.comune_spedizione = null;
            this.tecnico.cap_spedizione = null;
            this.tecnico.presso_spedizione = null;
            // Contatti
            this.tecnico.cellulare = null;
            this.tecnico.telefono_fisso = null;
            this.tecnico.altro_numero = null;
            this.tecnico.email = null;
            // showAltroNumero = false;
            this.tecnico.circolari_abilitate = true;
            this.tecnico.is_tesserino_altro_comitato = false;
            this.tecnico.is_visibile = true;

            this.tecnico.note = null;
            // this.tecnico.diplomi = [];
            this.tecnico.diplomi = [];
            this.tecnico.rinnovi = [];

            this.searchTimer = null; // Timer prima di effettuare chiamata API per gli indirizzi

            // Ricerca degli indirizzi di residenza
            this.residenzaSelected = null;
            this.residenzaOptions = [];
            this.isLoadingResidenzaSearch = false;
            this.residenzaSearchText = null;

            this.domicilioSelected = null;
            this.domicilioOptions = [];
            this.isLoadingDomicilioSearch = false;
            this.domicilioSearchText = null;

            this.spedizioneSelected = null;
            this.spedizioneOptions = [];
            this.isLoadingSpedizioneSearch = false;
            this.spedizioneSearchText = null;

            this.resetDiplomaInModifica();
            this.diplomaInModificaCorsoIdIniziale = null;
            this.diplomaInModificaEdizioneIdIniziale = null;

            this.resetRinnovoInModifica();

            this.funzioniInAttesaProvince = [];

            this.ricreaTecnicoCampiModificati();

            // this.tecnicoModificato = false;

            this.diplomaModificato = false;
            this.rinnovoModificato = false;
            
            try { // In certe circostanze poco rilevanti il seguente fallisce.
               this.$refs['formTecnico'].resetValidation()
            } catch (error) {}
         },

         ricreaTecnicoCampiModificati(){
            // Ricreo campi tecnico per aver traccia di ciò che è stato modificato:
            this.tecnicoCampiModificati = {};
            for(let prop in this.tecnico){
               this.tecnicoCampiModificati[prop] = false;
            }

            // Creo anche le sezioni per tenere traccia delle modifiche:
            this.sezioniModificate = {
               anagrafica: false,
               contatti: false,
               indirizzi: false,
               altri_dati: false,
            }
         },
         setTecnicoCampoModificato(nomeCampo){
            // Potre aver impostato anche intere 'parti' a true:
            if(nomeCampo == 'tutto_residenza'){
               this.tecnicoCampiModificati['indirizzo_residenza'] = true;
               this.tecnicoCampiModificati['civico_residenza'] = true;
               this.tecnicoCampiModificati['comune_residenza'] = true;
               this.tecnicoCampiModificati['nazione_residenza'] = true;
               this.tecnicoCampiModificati['sigla_provincia_residenza'] = true;
               this.tecnicoCampiModificati['cap_residenza'] = true;
               this.sezioniModificate['indirizzi'] = true;
            } else if(nomeCampo == 'tutto_domicilio') {
               this.tecnicoCampiModificati['indirizzo_domicilio'] = true;
               this.tecnicoCampiModificati['civico_domicilio'] = true;
               this.tecnicoCampiModificati['comune_domicilio'] = true;
               this.tecnicoCampiModificati['sigla_provincia_domicilio'] = true;
               this.tecnicoCampiModificati['cap_domicilio'] = true;
               this.sezioniModificate['indirizzi'] = true;
            } else if(nomeCampo == 'tutto_spedizione') {
               this.tecnicoCampiModificati['indirizzo_spedizione'] = true;
               this.tecnicoCampiModificati['civico_spedizione'] = true;
               this.tecnicoCampiModificati['comune_spedizione'] = true;
               this.tecnicoCampiModificati['sigla_provincia_spedizione'] = true;
               this.tecnicoCampiModificati['cap_spedizione'] = true;
               this.tecnicoCampiModificati['presso_spedizione'] = true;
               this.sezioniModificate['indirizzi'] = true;
            } else {
               this.tecnicoCampiModificati[nomeCampo] = true;
            }

            if(nomeCampo == 'nome' || nomeCampo == 'cognome' || nomeCampo == 'sesso' || nomeCampo == 'sigla_provincia_nascita' ||
                  nomeCampo == 'comune_nascita' || nomeCampo == 'data_nascita' || nomeCampo == 'codice_fiscale'){
               this.sezioniModificate['anagrafica'] = true;
            } else if (nomeCampo == 'cellulare' || nomeCampo == 'telefono_fisso' || nomeCampo == 'altro_numero' || nomeCampo == 'email') {
               this.sezioniModificate['contatti'] = true;
            } else if(nomeCampo == 'indirizzo_residenza' || nomeCampo == 'civico_residenza' || nomeCampo == 'comune_residenza' || nomeCampo == 'nazione_residenza' || nomeCampo == 'sigla_provincia_residenza' || nomeCampo == 'cap_residenza' || 
                  nomeCampo == 'indirizzo_domicilio' || nomeCampo == 'civico_domicilio' || nomeCampo == 'comune_domicilio' || nomeCampo == 'nazione_domicilio' || nomeCampo == 'sigla_provincia_domicilio' || nomeCampo == 'cap_domicilio' || 
                  nomeCampo == 'indirizzo_spedizione' || nomeCampo == 'civico_spedizione' || nomeCampo == 'comune_spedizione' || nomeCampo == 'nazione_spedizione' || nomeCampo == 'sigla_provincia_spedizione' || nomeCampo == 'cap_spedizione' || nomeCampo == 'presso_spedizione'
            ) {
               this.sezioniModificate['indirizzi'] = true;
            } else if(nomeCampo == 'referente_id' || nomeCampo == 'circolari_abilitate' || nomeCampo == 'is_tesserino_altro_comitato' || nomeCampo == 'is_visibile' || nomeCampo == 'note') {
               this.sezioniModificate['altri_dati'] = true;
            }

            // this.tecnicoModificato = true;
            this.$emit('tecnico-modificato');
         },

         getNazioni(){
            this.isLoadingNazioni = true;

            axios.get('/nazioni')
               .then(response => {
                  this.nazioni = JSON.parse(JSON.stringify(response.data));
               })
               .finally(() => {
                  this.isLoadingNazioni = false;
               });
         },

         getProvince(){
            if(this.isLoadingProvince)
               return;

            this.isLoadingProvince = true;
            this.province = [];

            axios.get("/province")
               .then(response => {
                  this.province = response.data;

                  this.province = JSON.parse(JSON.stringify(this.province));

                  // Nota sul funzionamento:
                  //    Alcune funzioni vanno eseguite solo dopo che le province sono state ottenute.
                  //    Le funzioni in attesa sono conservate in un array "funzioniInAttesaProvince"
                  //    Qui verranno eseguite e man mano eliminate
                  this.funzioniInAttesaProvince = this.funzioniInAttesaProvince.filter(fun => {
                     fun();
                     return false;
                  });

                  // Nuovamente dopo Xms per rare situazioni di corsa critica
                  setTimeout(() => {
                     this.funzioniInAttesaProvince = this.funzioniInAttesaProvince.filter(fun => {
                        fun();
                        return false;
                     });
                  }, 250);
               })
               .finally(() => {
                  this.isLoadingProvince = false;
               });
         },
         getComuniBySiglaProvincia(siglaProvincia, callback){
            // this.comuniByProvinciaResidenza = [];
            // this.capsByComuneResidenza = [];
            
            // Trasforma la sigla impostata al suo ID e con quello cerca i comuni
            if(siglaProvincia){
               // Se non ho ancora le informazioni delle province, metto la funzione tra quelle in attesa:
               if(this.province.length == 0){
                  this.funzioniInAttesaProvince.push(
                     () => this.getComuniBySiglaProvincia(siglaProvincia, callback)
                  )
                  return;
                  
                  // this.funzioniInAttesaProvince.push(() => this.getComuniBySiglaProvincia(siglaProvincia, callback))
                  // return;
               }

               // Prima trovo l'ID che non avevo salvato:
               let idProvincia = null;
               this.province.some(el=>{
                  if(el.sigla == siglaProvincia) {
                     idProvincia = el.id;
                     return true;
                  }
               });

               this.isLoadingComuni = true;

               axios.get(`/comuni/provincia/${idProvincia}`)
                  .then(response => {
                     callback(response.data);
                  })
                  .finally(() => {
                     this.isLoadingComuni = false;
                  });
            }
         },
         getIdComuneByComune(nomeComune, comuni){
            let idComune = null;
            comuni.some(el=>{
               if(el.nome == nomeComune){
                  idComune = el.id;
                  return true;
               }
            });
            return idComune;
         },
         getCapsByIdComune(idComune, callback){
            // this.capsByComuneResidenza = [];
            // if(this.tecnico.comune_residenza){
               // Prima trovo l'ID che non avevo salvato:
            //   let idComune = null;
            //   this.comuniByProvinciaResidenza.some(el=>{
            //     if(el.nome == this.tecnico.comune_residenza) {
            //       idComune = el.id;
            //       return true;
            //     }
            //   });

            this.isLoadingCaps = true;
            // this.caps = [];

            let q = `/caps/comune/${idComune}`;

            axios.get(q)
               .then(response => {
                  callback(response.data)
                  // this.capsByComuneResidenza = response.data;
               })
               .finally(() => {
                  this.isLoadingCaps = false;
               });
            // }
         },
         getReferenti(){
            axios.get('/referenti')
               .then(response => {
                  this.referenti = response.data;
               })
               .finally(() => {
               });
         },
         getCategorieCorsi(){
            axios.get('/categorie_corsi')
               .then(response => {
                  this.categorieCorsi = response.data;
               })
               .finally(() => {
               });
         },
         getCorsiByCategoriaCorsoId(categoriaCorsoId){
            axios.get('/corsi_by_categoria_id?id='+categoriaCorsoId)
               .then(response => {
                  this.corsiByCategoriaId = response.data;

                  // Se l'id del corso selezionato non è disponibile nel nuovo elenco, allora reimpostalo a null:
                  if(this.diplomaInModifica.corso_id != null){
                     let idTrovato = false;
                     this.corsiByCategoriaId.some((el)=>{
                        if(el.id == this.diplomaInModifica.corso_id){
                           idTrovato = true;
                           return true;
                        }
                     })

                     if(!idTrovato)
                        this.diplomaInModifica.corso_id = null;
                  }
               })
               .finally(() => {
               });
         },
         getEdizioniByCorsoId(corsoId){
            axios.get('/edizioni_by_corso_id?id='+corsoId)
               .then(response => {
                  this.edizioniByCorsoId = response.data;

                  // Se l'id dell'edizione del corso selezionato non è disponibile nel nuovo elenco, allora reimpostalo a null:
                  if(this.diplomaInModifica.edizione_id != null){
                     let idTrovato = false;
                     this.edizioniByCorsoId.some((el)=>{
                        if(el.id == this.diplomaInModifica.edizione_id){
                           idTrovato = true;
                           return true;
                        }
                     })

                     if(!idTrovato)
                        this.diplomaInModifica.edizione_id = null;
                  }
               })
               .finally(() => {
               });
         },
         getTecnico(){
            this.tecnicoAppenaOttenuto = false;
            if(this.tecnicoId == null){
               return;
            }

            this.isLoading = true;
            // axios.get(`/tecnici?page=${this.options.page}&itemsPerPage=${this.options.itemsPerPage}&search=${toSearch != null ? toSearch : ''}`)
            axios.get(`/tecnici/`+this.tecnicoId)
            .then(res => {
               this.tecnicoAppenaOttenuto = true; // Prima di far partire i watcher di nome, cognome, ecc..
               this.tecnico = res.data;

               this.tecnico.rinnovi.sort((a, b) => b.anno_rinnovo - a.anno_rinnovo);

               // PROBLEMA: al momento this.tecnico.sigla_provincia_domicilio è impostato,
               //          dopodiche this.tecnico.sigla_provincia_domicilio diventa null!!
               // SOLUZIONE: era dovuto al fatto che is_manuale_domicilio cambiava al caricamento, quindi resettava alcuni campi
               //          => controllo che tecnicoAppenaOttenuto sia a false per procedere

               // Dopo 3 cicli rimetto tecnicoAppenaOttenuto a False (dovrebbe aver saltato tutti i watcher che calcolano il CF):
               let self = this;
               this.$nextTick(() => {
                  self.$nextTick(() => {
                     self.$nextTick(() => {
                        self.tecnicoAppenaOttenuto = false;
                     });
                  });   
               });
               
               if(this.loggedAs && this.loggedAs.ruolo == 'tecnico' && this.tecnico.is_tour_completo == 0)
                  this.avviaTour();

               // Invio l'evento che invia nome e cognome al componente padre
               this.$emit('nome-cognome-tecnico-set', this.tecnico.nome + " " + this.tecnico.cognome);
            })
            .finally(() => {
               this.isLoading = false;
            })
         },
         calcolaCodiceFiscaleHelper(){ // Parte che effettua la richiesta vera e propria
            let q = "/fiscal_code/calculate?nome="+this.tecnico.nome+"&cognome="+this.tecnico.cognome+"&sesso="+this.tecnico.sesso+"&data_nascita="+this.tecnico.data_nascita+"&luogo_nascita="+this.tecnico.comune_nascita+"&sigla_provincia_nascita="+this.tecnico.sigla_provincia_nascita;
            
            this.isLoadingCodiceFiscale = true;
            axios.get(q)
               .then(response => {
                  // this.tecnico.is_codice_fiscale_manuale = 0;

                  // Mostro il CF come campo modificato solo se la modifica non è dovuta al primo caricamento
                  // Nota => Dopo le ultime modifiche non dovrebbe più chiamare il calcolo del codice fiscale se era il primo caricamento
                  if(/*!this.tecnicoAppenaOttenuto && */this.tecnico.codice_fiscale != response.data.codiceFiscale) // Se il cf è cambiato, allora segno la modifica
                     this.setTecnicoCampoModificato('codice_fiscale');
                  // else
                  //    this.tecnicoAppenaOttenuto = false;

                  this.tecnico.codice_fiscale = response.data.codiceFiscale;
               })
               .finally(() => {
                  this.isLoadingCodiceFiscale = false;
               })
         },
         calcolaCodiceFiscale(){
            clearTimeout(this.codiceFiscaleTimer);

            // Se è estero, interrompi e impostalo manuale:
            if(this.tecnico.sigla_provincia_nascita == 'EE'){
               if(this.tecnico.is_codice_fiscale_manuale == 0){ // Se prima era automatico, allora svuoto
                  this.tecnico.codice_fiscale = null;
                  this.tecnico.is_codice_fiscale_manuale = 1;
               }
               return;
            }

            // Se è manuale interrompi
            if(this.tecnico.is_codice_fiscale_manuale || this.tecnico.is_codice_fiscale_manuale == 1)
               return;

            if(this.tecnico.nome != null && this.tecnico.cognome != null && this.tecnico.sesso != null &&
                  this.tecnico.sigla_provincia_nascita != null && this.tecnico.comune_nascita != null &&
                  this.tecnico.data_nascita != null){
               
               this.codiceFiscaleTimer = setTimeout(this.calcolaCodiceFiscaleHelper, 500);
            }
         },
         // Mostra / Nascondi campo "Altro Numero" nella sezione Contatti
         toggleAltroNumero() {
            this.mostraAltroNumero = !this.mostraAltroNumero;
            this.tecnico.altro_numero = null;
            // if (!this.tecnico) {
            //   this.altroNumero = '';
            // }
         },
         copiaResidenzaInDomicilio() {
            this.tecnico.is_manuale_domicilio = false; // Quello di arrivo è sempre false perché non è veramente inserito a mano
            this.tecnico.indirizzo_domicilio = this.tecnico.indirizzo_residenza
            this.tecnico.civico_domicilio = this.tecnico.civico_residenza
            this.tecnico.is_snc_domicilio = this.tecnico.is_snc_residenza
            this.tecnico.nazione_domicilio = this.tecnico.nazione_residenza
            this.tecnico.sigla_provincia_domicilio = this.tecnico.sigla_provincia_residenza
            this.tecnico.comune_domicilio = this.tecnico.comune_residenza
            this.tecnico.cap_domicilio = this.tecnico.cap_residenza

            this.setTecnicoCampoModificato('tutto_domicilio')
         },
         // Residenza in Spedizione
         copiaResidenzaInSpedizione() {
            this.tecnico.is_manuale_spedizione = false; // Quello di arrivo è sempre false perché non è veramente inserito a mano
            this.tecnico.indirizzo_spedizione = this.tecnico.indirizzo_residenza
            this.tecnico.civico_spedizione = this.tecnico.civico_residenza
            this.tecnico.is_snc_spedizione = this.tecnico.is_snc_residenza
            this.tecnico.nazione_spedizione = this.tecnico.nazione_residenza
            this.tecnico.sigla_provincia_spedizione = this.tecnico.sigla_provincia_residenza
            this.tecnico.comune_spedizione = this.tecnico.comune_residenza
            this.tecnico.cap_spedizione = this.tecnico.cap_residenza

            this.setTecnicoCampoModificato('tutto_spedizione')
         },
         // Domicilio in Spedizione
         copiaDomicilioInSpedizione() {
            this.tecnico.is_manuale_spedizione = false; // Quello di arrivo è sempre false perché non è veramente inserito a mano
            this.tecnico.indirizzo_spedizione = this.tecnico.indirizzo_domicilio
            this.tecnico.civico_spedizione = this.tecnico.civico_domicilio
            this.tecnico.is_snc_spedizione = this.tecnico.is_snc_domicilio
            this.tecnico.nazione_spedizione = this.tecnico.nazione_domicilio
            this.tecnico.sigla_provincia_spedizione = this.tecnico.sigla_provincia_domicilio
            this.tecnico.comune_spedizione = this.tecnico.comune_domicilio
            this.tecnico.cap_spedizione = this.tecnico.cap_domicilio

            this.setTecnicoCampoModificato('tutto_spedizione')
         },
         cercaIndirizzo(searchText, callback){
            // La ricerca parte dopo Xs in cui non si è digitato nulla
            // clearTimeout(this.residenzaSearchTimer); // => SPOSTATO Nella chiamata a cercaIndirizzo()

            this.searchTimer = setTimeout(() => {
               // axios.get(`/tecnici?page=${this.options.page}&itemsPerPage=${this.options.itemsPerPage}&search=${toSearch != null ? toSearch : ''}`)
               // http://localhost:8000/autocomplete_location?query=via spagna 9, bian&tipo_ricerca=street
               axios.get(`/autocomplete_location?query=${searchText}&tipo_ricerca=street`)
               .then(res => {
                  let indirizzi = [];

                  res.data.results.forEach((el) => {
                     indirizzi.push({
                        nomeDaMostrare: el.street.name + " " + el.street.number + " - " + el.city + (el.countycode != '' ? " (" + el.countycode + ")" : "" ),
                        indirizzo: el.street.name,
                        civico: el.street.number,
                        comune: el.city,
                        provincia: el.county,
                        siglaProvincia: (el.countycode != '' ? el.countycode : 'EE'),
                        cap: el.zipcode[0]
                     })
                  })

                  callback(indirizzi);
               })
               .catch((error) => {})
               .finally(() => {
                  // self.isLoadingResidenzaSearch = false; // Spostata in callback
               })
            }, 1000);

         },

         validaTecnico(){
            if(this.$refs['formTecnico'].validate()){
               return true;
				} else {
               // Controllo i dati che mancano e mi sposto sulla tab corretta
               if(this.tecnico.nome == null || this.tecnico.cognome == null || this.tecnico.sesso == null ||
                  this.tecnico.sigla_provincia_nascita == null || this.tecnico.comune_nascita == null ||
                  this.tecnico.data_nascita == null || this.tecnico.codice_fiscale == null ||
                  this.tecnico.nome == '' || this.tecnico.cognome == '' ||
                  this.tecnico.data_nascita == '' || this.tecnico.codice_fiscale == ''){
                     this.tab = 0;
               } else if(this.loggedAs.ruolo != 'admin' && (this.tecnico.email == null || this.tecnico.email == '')){
                  this.tab = 1;
               } else if(this.tecnico.indirizzo_residenza == null || this.tecnico.nazione_residenza == null || this.tecnico.sigla_provincia_residenza == null ||
                  this.tecnico.comune_residenza == null || this.tecnico.cap_residenza == null || this.tecnico.indirizzo_residenza == ''){
                     this.tab = 2;
               }
               return false;
				}
         },

         aggiungiModificaTecnico(callbackSuccess = null){
            // Si dà per scontato che giunti qui la validazione sia già andata a buon fine
            if(this.tecnico.id == null || this.tecnico.id.id == ''){ // Nuovo tecnico
               axios.post('/tecnici', this.tecnico)
                  .then(res => {
                     if(callbackSuccess != null)
                        callbackSuccess(res.data) // res.data contiene il tecnico aggiunto
                  })
            } else { // Aggiornamento tecnico esistente
               axios.patch(`/tecnici/${this.tecnico.id}`, this.tecnico)
                  .then(res => {
                     if(callbackSuccess != null)
                        callbackSuccess(this.tecnico)
                  })
            }
		   },

         aggiungiTecnicoSenzaChiudereDialog(vaiATab){
            this.$emit('aggiungi-tecnico-senza-chiudere-dialog', vaiATab);
         },

         // ================== Diplomi ==================
         resetDiplomaInModifica(){
            this.diplomaInModifica.isNew = true;
            this.diplomaInModifica.categoria_corso_id = null
            this.diplomaInModifica.corso_id = null
            this.diplomaInModifica.nome_corso = null
            this.diplomaInModifica.edizione_id = null
            this.diplomaInModifica.nome_edizione = null
            this.diplomaInModifica.data_conseguimento = null

            this.diplomaModificato = false;

            try { // Se il componente non è ancora stato costruito fallirà.
               this.$refs['formDiplomaTecnico'].resetValidation()      
            } catch (error) {}
            
         },
         openDiplomaDialog(diploma){
            this.corsiByCategoriaId = [];
            this.edizioniByCorsoId = [];

            this.diplomaDialog = true;

            // Inizialmente resetto tutti i campi (come fosse un nuovo diploma)
            // this.resetDiplomaInModifica(); // Non va fatto in teoria

            this.diplomaInModificaCorsoIdIniziale = null;
            this.diplomaInModificaEdizioneIdIniziale = null;

            if(diploma){
               this.diplomaInModifica = JSON.parse(JSON.stringify(diploma));
               this.diplomaInModifica.isNew = false; // Segnala che NON è un nuovo elemento

               // Mantengo i riferimenti ai dati originali/iniziali per sapere poi quale modificare dall'elenco
               this.diplomaInModificaCorsoIdIniziale = this.diplomaInModifica.corso_id;
               this.diplomaInModificaEdizioneIdIniziale = this.diplomaInModifica.edizione_id;
            }
         },
         closeDiplomaDialog(daConfermare = true){
            if(this.diplomaModificato && daConfermare){
					store.commit('mostraDialogConferma', 
						{
							titolo: 'Esci senza salvare le modifiche',
							testo:'Sono presenti delle modifiche, vuoi uscire senza salvarle?', 
							onConferma:()=>{
								this.diplomaDialog = false;
                        this.resetDiplomaInModifica();
								store.commit('nascondiDialogConferma');
							}, 
							onAnnulla:()=>{
								store.commit('nascondiDialogConferma');
							}
						}
					)
				} else {
					this.diplomaDialog = false;
               this.resetDiplomaInModifica();
				}
         },
         getDiplomiTecnico(){
            axios.get('/diplomi_tecnico/'+this.tecnico.id)
               .then(res => {
                  this.tecnico.diplomi = res.data;
               })
               .catch(error => {})
               .finally(() => {
                  // this.personalDataEdited = false;
               });
         },

         validaDiploma(){
            if(this.$refs['formDiplomaTecnico'].validate()){
               this.inserisciModificaDiploma()
				} else {
               return
				}
         },
         inserisciModificaDiploma(){
            // Arriva qui dopo la validazione
            if(this.tecnico.id == null){
               store.commit('mostraSnack', {messaggio: 'Non si può aggiungere un diploma ad un tecnico non ancora salvato', tipo: 'error'})
               return;
            }

            if(this.diplomaInModifica.isNew){ // Nuovo diploma
					axios.post('/aggiungi_diploma_tecnico', {...this.diplomaInModifica, tecnico_id: this.tecnico.id})
						.then(res => {
                     this.getDiplomiTecnico()
                     this.closeDiplomaDialog(false)

                     store.commit('mostraSnack', {messaggio: 'Diploma inserito con successo', tipo: 'success'})
                     // Se è il primo diploma dell'anno allora avrà inserito anche il rinnovo:
                     this.getRinnoviTecnico();

                     // Mostro la sezione come modificata
                     this.sezioniModificate['diplomi'] = true;
                     this.$emit('tecnico-modificato');
						})
				} else { // Aggiornamento diploma esistente
					axios.patch(`/modifica_diploma_tecnico`, 
                  {
                     ...this.diplomaInModifica, 
                     tecnico_id: this.tecnico.id, 
                     corso_id_originale: this.diplomaInModificaCorsoIdIniziale, 
                     edizione_id_originale: this.diplomaInModificaEdizioneIdIniziale
                  })
						.then(res => {
                     this.getDiplomiTecnico()
                     this.closeDiplomaDialog(false)

                     store.commit('mostraSnack', {messaggio: 'Diploma modificato con successo', tipo: 'success'})

                     // Se è il primo diploma dell'anno allora avrà inserito anche il rinnovo:
                     this.getRinnoviTecnico();

                     // Mostro la sezione come modificata
                     this.sezioniModificate['diplomi'] = true;
                     this.$emit('tecnico-modificato');
						})
				}
         },
         eliminaDiploma(diploma){
            store.commit('mostraDialogConferma', 
					{
						titolo: 'Elimina diploma del tecnico', 
						testo:`Sicuro di voler eliminare questo diploma del tecnico?`,
						onConferma:()=>{
							// Nota: se lo metto come DELETE non posso passare payload
                     axios.post('/elimina_diploma_tecnico', {...diploma, tecnico_id: this.tecnico.id})
                        .then(res => {
                           this.getDiplomiTecnico()
                           this.closeDiplomaDialog(false)
                           store.commit('mostraSnack', {messaggio: 'Diploma eliminato con successo', tipo: 'success'})

                           // Se era l'unico diploma e vi era un rinnovo creato appositamente, sarà stato eliminato:
                           this.getRinnoviTecnico();

                           // Mostro la sezione come modificata
                           this.sezioniModificate['diplomi'] = true;
                           this.$emit('tecnico-modificato');
                        })
							store.commit('nascondiDialogConferma')
						}, 
						onAnnulla:()=>{
							store.commit('nascondiDialogConferma')
						}
					}
				)
         },
         // =============================================

         // ================== Rinnovi ==================
         resetRinnovoInModifica(){
            this.rinnovoInModifica.isNew = true;
            this.rinnovoInModifica.id = null;
            this.rinnovoInModifica.anno_rinnovo = null;
            this.rinnovoInModifica.modalita_pagamento = null;
            this.rinnovoInModifica.note = null;
            // this.rinnovoInModifica.utente_id = null; // Inserito al momento del salvataggio
            // this.rinnovoInModifica.rinnovo_manuale_utente_id = null; // Gestito da BE

            this.rinnovoModificato = false;

            try { // Se il componente non è ancora stato costruito fallirà.
               this.$refs['formRinnovoTecnico'].resetValidation();
            } catch (error) {}
         },
         openRinnovoDialog(rinnovo){
            this.rinnoviDialog = true;

            if(rinnovo){
               this.rinnovoInModifica = JSON.parse(JSON.stringify(rinnovo));
               this.rinnovoInModifica.anno_rinnovo = parseInt(this.rinnovoInModifica.anno_rinnovo);

               this.rinnovoInModifica.isNew = false;

               if(!this.anniRinnoviOptions.includes(this.rinnovoInModifica.anno_rinnovo)){
                  this.anniRinnoviOptions.push(this.rinnovoInModifica.anno_rinnovo);
                  // Riordino per data
                  this.anniRinnoviOptions.sort((a, b) => a - b); // Dal più piccolo al più grande
               }
            }
            // Il seguente non serve farlo in teoria perché resettato quando chiuso l'ultima volta
            // else {
            //    this.resetRinnovoInModifica();
            // }
         },
         closeRinnovoDialog(daConfermare = true){
            if(this.rinnovoModificato && daConfermare){
					store.commit('mostraDialogConferma', 
						{
							titolo: 'Esci senza salvare le modifiche',
							testo:'Sono presenti delle modifiche, vuoi uscire senza salvarle?', 
							onConferma:()=>{
								this.rinnoviDialog = false;
                        this.resetRinnovoInModifica();
								store.commit('nascondiDialogConferma');
							}, 
							onAnnulla:()=>{
								store.commit('nascondiDialogConferma');
							}
						}
					)
				} else {
					this.rinnoviDialog = false;
               this.resetRinnovoInModifica();
				}
         },
         getRinnoviTecnico(){
            axios.get('/rinnovi_by_tecnico?tecnico_id='+this.tecnico.id)
               .then(res => {
                  this.tecnico.rinnovi = res.data;
                  // this.tecnico.rinnovi.reverse();
               });
         },
         validaRinnovo(){
            if(this.$refs['formRinnovoTecnico'].validate()){
               this.inserisciModificaRinnovo()
				} else {
               return
				}
         },
         inserisciModificaRinnovo(){
            if(this.tecnico.id == null){
               store.commit('mostraSnack', {messaggio: 'Non si può aggiungere un rinnovo ad un tecnico non ancora salvato', tipo: 'error'})
               return;
            }

            if(this.rinnovoInModifica.isNew){ // Nuovo rinnovo
					axios.post('/rinnovi', {...this.rinnovoInModifica, tecnico_id: this.tecnico.id})
						.then(res => {
                     this.getRinnoviTecnico()
                     this.closeRinnovoDialog(false)
                     store.commit('mostraSnack', {messaggio: 'Rinnovo inserito con successo', tipo: 'success'})
                     // Mostro la sezione come modificata
                     this.sezioniModificate['rinnovi'] = true;
                     this.$emit('tecnico-modificato');
						})
				} else { // Aggiornamento rinnovo esistente
					axios.patch(`/rinnovi/${this.rinnovoInModifica.id}`, { ...this.rinnovoInModifica, tecnico_id: this.tecnico.id})
						.then(res => {
                     this.getRinnoviTecnico()
                     this.closeRinnovoDialog(false)
                     store.commit('mostraSnack', {messaggio: 'Rinnovo modificato con successo', tipo: 'success'})
                     // Mostro la sezione come modificata
                     this.sezioniModificate['rinnovi'] = true;
                     this.$emit('tecnico-modificato');
						})
				}
         },
         eliminaRinnovo(rinnovoId){
            store.commit('mostraDialogConferma', 
					{
						titolo: 'Elimina rinnovo del tecnico', 
						testo:`Sicuro di voler eliminare questo rinnovo del tecnico?`,
						onConferma:()=>{
							axios.delete(`/rinnovi/${rinnovoId}`)
                        .then(res => {
                           this.getRinnoviTecnico()
                           this.closeRinnovoDialog(false)
                           store.commit('mostraSnack', {messaggio: 'Rinnovo eliminato con successo', tipo: 'success'})
                           
                           // Mostro la sezione come modificata
                           this.sezioniModificate['rinnovi'] = true;
                           this.$emit('tecnico-modificato');
                        })
							store.commit('nascondiDialogConferma')
						}, 
						onAnnulla:()=>{
							store.commit('nascondiDialogConferma')
						}
					}
				)
         },
         stampaEtichetta(rinnovo) {
            // this.isDownloadingPDFBollino = true;

            window.open("/etichetta_pdf/" + rinnovo.id, '_blank');

            // Qui facevo partire il download dalla stessa pagina
            // Invia la richiesta POST al server
				// axios.post('etichetta_pdf', {'id': rinnovo.id}, {
				// 	responseType: 'blob' // Importante! Indica che la risposta sarà un blob (file binario)
				// })
				// .then((response) => {
				// 	console.log(response)
				// 	// // Crea un URL per il blob
				// 	const blob = new Blob([response.data], { type: 'application/pdf' });
				// 	const link = document.createElement('a');
				// 	link.href = window.URL.createObjectURL(blob);
				// 	link.download = `Bollino ${rinnovo.anno_rinnovo}.pdf`; // Nome del file che vuoi scaricare
				// 	link.click(); // Simula il clic per avviare il download

				// 	// Libera la memoria dopo il download
				// 	window.URL.revokeObjectURL(link.href);

				// 	// this.isExportingPDF = false;
				// })
				// .catch((error) => {
				// 	console.error('Errore durante il download del PDF', error);
				// 	// this.isExportingPDF = false;
				// })
            // .finally(()=>{
            //    this.isDownloadingPDFBollino = false;
            // });

         },

         pagamentoRinnovo(){
            // window.open("/rinnovo-pagamento", '_blank').focus();
            window.location.href = "/rinnovo-pagamento";
         },
         pagamentoRinnovoAltroAnno(){
            if(!this.$refs['formRinnovoAltriAnni'].validate())
               return

            window.location.href = `/rinnovo-pagamento?anno=${this.annoRinnovoAltriAnni}`;
         },
         openRinnovoAltriAnniDialog(){
            // Permette di acquistare rinnovi per anni diversi dall'attuale
            this.annoRinnovoAltriAnni = null;
            this.rinnovoAltriAnniDialog = true;
         },
         closeRinnovoAltriAnniDialog(){
            this.annoRinnovoAltriAnni = null;
            this.rinnovoAltriAnniDialog = false;
         },
         // =============================================

         haRinnovoPerAnno(anno){
            // true se ha un rinnovo per l'anno in input
            if(this.tecnico.rinnovi == null)
               return false

            let trovato = false;
            this.tecnico.rinnovi.some(rinnovo => {
               if(parseInt(rinnovo.anno_rinnovo) == parseInt(anno)){
                  trovato = true;
                  return true;
               }
            });

            return trovato;
         },
         haReferenteAutonomo(){
            if(this.tecnico.referente && parseInt(this.tecnico.referente.autogestisce_rinnovi) == 1)
               return true;

            return false;
         },

         rendiTecnicoInvisibile(){
            if(!this.tecnico.is_visibile && this.tecnico.circolari_abilitate){ // Disattivo anche la ricezione di circolari (se abilitate)
               this.tecnico.circolari_abilitate = false;
               this.setTecnicoCampoModificato('circolari_abilitate'); // Informo delle modifiche
            }
            
            this.setTecnicoCampoModificato('is_visibile'); // Informo delle modifiche
         }

      },
      computed: {

         annoRinnovoAltriAnniTextComputed(){
            if(this.annoRinnovoAltriAnni == null) 
               return ""

            return `Dopo aver acquistato, il rinnovo selezionato sarà valido dal <b>01/01/${this.annoRinnovoAltriAnni}</b> al <b>31/12/${this.annoRinnovoAltriAnni}</b>`
         },

         ruleEmailComputed(){
            if(this.loggedAs && this.loggedAs.ruolo == 'admin'){
               return [this.rules.email];
            } else {
               return [this.rules.required, this.rules.email];
            }
         },

         isCodiceFiscaleModificabileComputed(){
            // Il codice fiscale è modificabile manualmente dal tecnico solo se ha potuto modificare uno degli altri campi (perché mancanti) o se è vuoto
            return (this.loggedAs && this.loggedAs.ruolo == 'admin') || this.sezioniModificate['anagrafica'] || this.tecnico.codice_fiscale == null || this.tecnico.codice_fiscale == '';
         },

         tourStepsComputed(){ // Solo relativo ai tecnici
            let tourStep = [
               {
                  target: '#anagrafica-tab',
                  // header: {
                  //    title: 'Titolo test',
                  // },
                  content: `Benvenuto, segui questa breve guida per scoprire quanto è semplice usare l'Albo Tecnici CSEN Corsi!<br/><br/>
                     Guarda subito questa sezione: qui puoi trovare i tuoi dati anagrafici, controlla che siano tutti compilati e corretti!<br/><br/>
                     Se dovesse mancare qualche dato, puoi aggiungerlo in autonomia. Se vuoi modificare i dati esistenti invia un'email a <a class="dark:!text-white underline" href="mailto:info@tecnici.csencorsi.it">info@tecnici.csencorsi.it</a>.<br/><br/>
                     Clicca su "Successivo" per continuare la guida.`,
                  before: () => {
                     this.tab = 0
                  }
               },
               {
                  target: '#contatti-tab',
                  content: `In questa sezione puoi visualizzare o modificare i tuoi dati di contatto.<br/><br/>
                     Se dovessero essere incompleti potrai aggiungerli al primo accesso.`,
                  before: () => {
                     this.tab = 1
                  }
               },
               {
                  target: '#indirizzi-tab',
                  content: `Qui troverai l’indirizzo di residenza, di domicilio e di spedizione.<br/><br/>
                     Basterà scorrere in basso per vedere tutti i campi.<br/><br/>
                     1/2 `,
                  before: () => {
                     this.tab = 2
                  }
               },
               {
                  target: '#indirizzi-tab-in',
                  content: `Quando devi inserire un indirizzo usa la barra di ricerca per trovarlo facilmente.<br/><br/>
                     Se non lo trovi oppure qualche dato non è corretto, spunta la casella “Inserisci manualmente”.<br/><br/>
                     Dopo aver inserito l'indirizzo di residenza, clicca sul pulsante “Copia indirizzo di residenza/domicilio” se coincidono.<br/><br/>
                     2/2`,
                  before: () => {
                     this.tab = 2
                  }
               },
               {
                  target: '#diplomi-tab',
                  content: `In questa sezione puoi vedere tutti i diplomi conseguiti con noi!`,
                  before: () => {
                     this.tab = 3
                  }
               }
            ];

            if(this.haReferenteAutonomo()){
               tourStep.push({
                  target: '#rinnovi-tab',
                  content: `
                     Cliccando su questa sezione “Rinnovi” puoi vedere lo storico di tutti i rinnovi effettuati.<br/><br/>
                     Se devi rinnovare per l'anno in corso, ricordati di contattare il tuo Referente.
                  `,
                  before: () => {
                     this.tab = 4
                  }
               });
            } else {
               tourStep.push({
                  target: '#rinnovi-tab',
                  content: `
                     Cliccando su questa sezione “Rinnovi” puoi vedere lo storico dei rinnovi effettuati e rinnovare il patentino in autonomia, pagando online in modo sicuro con carta di credito, debito o Postepay.
                  `,
                  before: () => {
                     this.tab = 4
                  }
               });
            }

            // Se non hanno rinnovato vengono avvisati su dove cliccare:
            if(!this.haRinnovoPerAnno(new Date().getFullYear()) && !this.haReferenteAutonomo()){
               tourStep.push({
                  target: '#procedi-rinnovi',
                  content: `Clicca qui per acquistare il rinnovo di quest'anno del tuo patentino CSEN!`
               });
            }

            if(!this.haReferenteAutonomo()){
               tourStep.push({
                  target: '#rinnovi-altri-anni',
                  content: `Se desideri rinnovare il patentino per il prossimo anno o recuperare il rinnovo di un anno precedente che hai saltato, clicca su questo pulsante!`
               });
            }

            tourStep.push(
               {
                  // target: '#etichetta-rinnovo-header', => Questa da mobile non funziona perché scompare intestazione
                  target: '#rinnovi-table',
                  content: `Qui troverai tutti i rinnovi, già effettuati o futuri dal primo in poi. Per ogni anno puoi stampare il bollino.<br/><br/>
                     Nel foglio di stampa troverai le istruzioni per ritagliare e incollare il bollino sul patentino.`,
                  params: { 
							placement: 'top'
						}
               },
               {
                  target: '#salva-modifiche',
                  content: `Dopo aver aggiunto/modificato una o più sezioni clicca su “Salva e torna all'elenco” per chiudere la scheda del tecnico e tornare all'elenco dei tecnici.<br/><br/>
                     Se hai dubbi sul funzionamento, non esitare a scriverci all'email <a class="dark:!text-white underline" href="mailto:info@tecnici.csencorsi.it">info@tecnici.csencorsi.it</a>! :)`
               },
               {
                  target: '#dark-mode',
                  content: `
                     Cliccando su questo pulsante puoi scegliere il tema dello sfondo dell'app: chiaro o scuro!<br/><br/>
                     Consigliamo il tema chiaro nelle ore diurne e quello scuro nelle ore serali per non appesantire la vista ;)
                  `
               },
               {
                  target: '#guida-btn',
                  content: `
                     Grazie per aver seguito tutta la Guida!<br/><br/>
                     Ricorda che puoi riaprirla in ogni momento cliccando qui su "Mostra Guida".<br/><br/>
                     Saluti sportivi!
                  `
               },
            );

            return tourStep
         },

         headersRinnoviComputed(){
            let headers = [
               { text: "Anno di Rinnovo", value: "anno_rinnovo", sortable: false, class: 'text-center' }
            ];

            if(this.loggedAs && this.loggedAs.ruolo == 'admin'){
               headers.push({ text: "Modalità di Rinnovo", value: "modalita_pagamento", sortable: false, class: 'text-center' });
               headers.push({ text: "Data di acquisto", value: "created_at", sortable: false, class: 'text-center' });
               headers.push({ text: "Note", value: "note", sortable: false, class: 'text-center' });
               headers.push({ text: "", value: "stampa_etichetta", sortable: false, class: 'text-center' }); // Text definito nello slot
               headers.push({ text: "Azioni", value: "azioni", sortable: false, class: 'text-center' });
            } else {
               headers.push({ text: "", value: "stampa_etichetta", sortable: false, class: 'text-center' }); // Text definito nello slot
            }

            return headers;
         },

         headersDiplomiComputed(){
            let headers = [
               { text: "Diploma", value: "nome_corso", sortable: false },
               { text: "Data di Conseguimento", value: "data_conseguimento", sortable: false},
               { text: "Edizione Corso", value: "nome_edizione", sortable: false},
            ];

            if(this.loggedAs && this.loggedAs.ruolo == 'admin'){
               headers.push({ text: "Azioni", value: "azioni", sortable: false, class: '!text-center' });
            }

            return headers;
         },

         isRinnovoScadutoComputed(){
            let isScaduto = true;
            this.tecnico.rinnovi.some(rinnovo => {
               if(rinnovo.anno_rinnovo == new Date().getFullYear()){
                  isScaduto = false;
                  return true;
               }
            })

            return isScaduto;
         },

         isRinnovatoAnnoSuccessivoComputed(){
            let rinnovato = false;
            this.tecnico.rinnovi.some(rinnovo => {
               if(rinnovo.anno_rinnovo == (new Date().getFullYear())+1){
                  rinnovato = true;
                  return true;
               }
            })

            return rinnovato;
         },

         anniDisponibiliRinnovoAltriAnni(){
            // In quest'elenco ci devono essere gli anni per cui non ha rinnovato dal primo rinnovo al prossimo anno
            //    (ad esclusione inoltre anche dell'anno attuale) => Questo non è più richiesto!

            let anniPresenti = [];
            this.tecnico.rinnovi.forEach(el => {
               anniPresenti.push(parseInt(el.anno_rinnovo));
            });
            anniPresenti.sort((a, b) => a - b); // Adesso sono ordinati dal più piccolo al più grande

            let annoAttuale = new Date().getFullYear();

            let anniSelezionabili = [];
            if(anniPresenti.length > 0){
               let annoConsiderato = anniPresenti[0] + 1; // Il successivo dell'anno di partenza
               while(annoConsiderato <= annoAttuale+1){ // Può acquistare fino all'anno successivo all'attuale
                  if(!anniPresenti.includes(annoConsiderato) /*&& annoConsiderato != annoAttuale*/){
                     anniSelezionabili.push(annoConsiderato)
                  }
                  annoConsiderato++;
               }
            } else { // Chi non ha rinnovi deve comunque poter acquistare l'anno attuale e successivo:
               anniSelezionabili.push(annoAttuale);
               anniSelezionabili.push(annoAttuale+1);
            }

            anniSelezionabili.reverse()
            
            return anniSelezionabili;
         },

         ruleEdizioneCorso(){
            // Se il corso selezionato non ha edizioni, la validazione va sempre a buon fine
            if(this.edizioniByCorsoId.length == 0){
               return true;
            } 
               
            else { // Altrimenti è necessario aver selezionato l'edizione
               if(this.diplomaInModifica.edizione_id != null && this.diplomaInModifica.edizione_id != ''){
                  return true;
               } else {
                  return "E' necessario selezionare l'edizione";
               }
            }
		   }
      }
   };
</script>

<style>
   .v-step {
      max-width: 400px !important;
      background-color: #f1861b !important;
   }
   .v-step__button-next {
      background-color: #2196f3 !important;
      border-color: #2196f3 !important;
   }
   .v-step__button-next:hover {
      color: white !important;
      background-color: #2196f3 !important;
   }
   .v-tour__target--highlighted {
      box-shadow: 0 0 0 4px rgb(33, 150, 243);
   }
   .v-tour__target--highlighted--inset {
      box-shadow: inset 0 0 0 4px rgb(33, 150, 243);
   }

   /* Per far in modo che i menù si aprano anche sopra la sticky bar sottostante con i pulsanti di salvataggio */
   .v-menu__content{
      z-index: 99999 !important;
   }

   .v-messages__message {
      color:#BC2025 !important;
   }

</style>
